import React, { useState, useRef, useEffect } from 'react';
import Nav from "../../components/Nav";
import Body from "../../components/Body";
import { useParams } from "react-router-dom";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Panel } from 'primereact/panel';
import "./AuditForm.css";
import "./AuditView.css";
import { Divider } from 'primereact/divider';
import { ScrollPanel } from 'primereact/scrollpanel';
import { InputTextarea } from 'primereact/inputtextarea';
import { FileUpload, FileUploadBeforeUploadEvent, FileUploadSelectEvent } from 'primereact/fileupload';
import { useSearchParams } from 'react-router-dom'
import { InputText } from 'primereact/inputtext';
import { InputSwitch } from 'primereact/inputswitch';
import { useNavigate } from "react-router-dom";
import { ProgressBar } from 'primereact/progressbar';
import { Toast } from 'primereact/toast';
import { Avatar } from 'primereact/avatar';
import { authenticatedFetch, getAuthenticatedHeader } from "../../state/apiUtils";
import useHasRole from "../../hooks/validRolesHook";
import NotFound from "../Global/404NotFound";
import Loading from "../Global/loading";
import { Tag } from 'primereact/tag';
import { jsPDF } from "jspdf";
import {useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";


export default function AuditView() {
    const navigate = useNavigate();
    const toast = useRef<Toast>(null);

    const { id } = useParams();

    //const { id } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();

    const auditReviewId = searchParams.get('auditReviewId');
    const auditFindingId = searchParams.get('auditFindingId');
    const [auditPlanType, setAuditPlanType] = useState<string>();

    //Determine if this is for Finding or QC
    const [mode, setMode] = useState<string>();

    //Determine which role is being used
    const userRole = searchParams.get('Role');

    //All the fields about a Loan
    const [loanData, setLoanData] = useState<any>({});

    const [findingData, setFindingData] = useState<any>({});

    //Upload attachment file State
    const [attachmentFileData, setAttachmentFileData] = useState(
        {
            loading: true, data: "", fileID: "", fileName: ""
        }
    );

    //Contains all the checklist items
    const [checklistData, setchecklistData] = useState<any>({
        checklists: []
    });

    // Contains all attachments
    const [attachmentData, setAttachmentData] = useState<any[]>([]);
    const [attachmentDataFetched, setAttachmentDataFetched] = useState<boolean>(false);


    //The selected Attachment for viewing
    const [selectedAttachment, setSelectedAttachment] = useState<any>(null)

    const [noteData, setNoteData] = useState<any[]>([]);
    const [noteFetched, setNoteFetched] = useState<boolean>(false);

    const [activityData, setActivityData] = useState<any[]>([]);
    const [activityDataFetched, setActivityDataFetched] = useState<boolean>(false);

    //List of questions for a selected checklist
    const [selectedChecklist, setSelectedChecklist] = useState<any>(null)


    //Which page to show up on the right-hand section
    const [activePage, setActivePage] = useState<any>("Loan")

    //All the response records from API
    const [allResponses, setAllResponses] = useState<any[]>([])


    //For viewing findings
    const [auditFindings, setAuditFindings] = useState<any[]>([]);
    const [auditFindingsFetched, setAuditFindingsFetched] = useState<boolean>(false);

    //The selected Finding for viewing
    const [selectedAuditFinding, setSelectedAuditFinding] = useState<any>({})

    //For viewing completed items
    const [completedResponses, setCompletedResponses] = useState<any[]>([]);

    //to determine if we are showing only unaswered questions
    const [checklistNoResponseOnly, setChecklistNoResponseOnly] = useState<boolean>(false);

    const [questionLoading, setQuestionLoading] = useState<boolean>(false);
    const [refreshResponse, setResponseResponse] = useState<boolean>(false);

    //Alert for QC Complete
    const [QCCompleteAlert, setQCCompleteAlert] = useState<boolean>(false);
  //const[checkListedResponseData,setCheckListedResponseData]=useState<Record<string, any>>({});
    const [header, setHeader] = useState<any>();
    const checkListedResponseRef = useRef<Record<string, any>>({});
   // <Page_Questions checkListedResponseRef={checkListedResponseRef} />

   // Instead of storing per checklist, store ALL
const allChecklistsResponsesRef = useRef<Record<string, Record<string, any>>>({});
const { instance, accounts } = useMsal();
const [idTokenClaims, setIdTokenClaims] = useState(null);
const [pdfResponses, setPdfResponses] = useState<any[]>([]);

    useEffect(() => {

        prepareAuditOrFinding();
        initHeader();

    }, []);

   
    useEffect(() => {
            // Silently acquires an access token which is then attached to a request for MS Graph data
            if(accounts.length > 0){
                instance.setActiveAccount(accounts[0]);
            }
            instance.acquireTokenSilent({
                ...loginRequest,
                account: accounts[0]
            }).then((response) => {
                // @ts-ignore
                setIdTokenClaims(response.account.idTokenClaims);
                //getUserInfo();
            });
        }, [instance, accounts]);

        //console.log("idTokenClaims:", idTokenClaims);
    
    useEffect(() => {

        if (auditPlanType == null) {
            return;
        }
        if (auditFindingId != null) {
            setMode("FINDING");
            getFindingValidationData(auditFindingId)
        }
        else {
            setMode("QC");

            //get back all the findings
            getFindingsData();
        }

        getAttachmentData();

        getNoteData();

        getActivityData(); 

        //Get back all the responses
        getResponses(null);
        getResponsesForPDF();

    }, [auditPlanType])

    
    useEffect(() => {
        if (allResponses.length > 0)
            updateResponseTally()
    }, [allResponses])

    const initHeader = () => {
        getAuthenticatedHeader().then((response) => {
            setHeader(response);
        })
    }

    // 1️⃣ Declare the function first
const populateAllChecklistResponses = () => {
    checklistData?.checklists.forEach((category: any) => {
        const responseRecord: Record<string, any> = {};

        category.Questions.forEach((q: any) => {
            const match = allResponses.find((r: any) => r.QcChecklistId === q.QcChecklistId);
            if (match) {
                responseRecord[q.QcChecklistId] = { ...match, saved: true };
            } else {
                responseRecord[q.QcChecklistId] = {
                    QcChecklistId: q.QcChecklistId,
                    Response: "",
                    DefectCategory: "",
                    DefectSubCategory: "",
                    DefectName: "",
                    SeverityRating: "",
                    AreaResponsible: {},
                    saved: false
                };
            }
        });

        allChecklistsResponsesRef.current[category.Category] = responseRecord;
    });
};

// 2️⃣ Then call it in useEffect
useEffect(() => {
    if (checklistData && allResponses) {
        populateAllChecklistResponses();
    }
}, [checklistData, allResponses]);


  
    const prepareAuditOrFinding = () => {
        //Get Audit Review Plan Type
        authenticatedFetch(
            "/Audit/GetAuditPlanType?auditReviewId=" + auditReviewId)
            .then(res => {

                

                setAuditPlanType(res.AuditPlanType);
                //Get Loan Details
                getLoanData(res.MonthlyFundedLoanId);

                //Get checklist information
                getCheckListData(res.MonthlyFundedLoanId, res.AuditPlanType);
            });

    }
    
    //Get back all the questions for this loan
    const getLoanData = (id: any) => {
        authenticatedFetch(
            "/Audit/GetLoanData?LoanId=" + id)
            .then(res => {
                var data = res;
                setLoanData(data);
            });
    }

    const getFindingsData = () => {
        var param = {
            AuditReviewId: auditReviewId
        }
        authenticatedFetch(
            "/Audit/GetFindings", {
            method: "POST",
            body: JSON.stringify(param),
            headers: {
                "Content-Type": "application/json",
            }
        }).then(res => {
            var data = res;
            setAuditFindings(data.Responses);
            setAuditFindingsFetched(true);
        });
    }

    const getFindingValidationData = (id: any) => {
        var param = {
            AuditFindingId: id
        }
        authenticatedFetch(
            "/Finding/GetFindingValidations", {
            method: "POST",
            body: JSON.stringify(param),
            headers: {
                "Content-Type": "application/json",
            }
        }).then(res => {
            var data = res;
            setSelectedAuditFinding(data);
            setActivePage("Finding");
            setAuditFindingsFetched(true);
        });
    }

    const getAttachmentData = () => {
        var param = {
            AuditReviewId: auditReviewId
        }
        authenticatedFetch(
            "/Attachment/GetReviewAttachments", {
            method: "POST",
            body: JSON.stringify(param),
            headers: {
                "Content-Type": "application/json",
            }
        }).then(res => {
            var data = res;
            setAttachmentData(data);
            setAttachmentDataFetched(true);
        });
    }

    const getActivityData = () => {
        var param = {
            AuditReviewId: auditReviewId
        }
        authenticatedFetch(
            "/Activity/GetActivities", {
            method: "POST",
            body: JSON.stringify(param),
            headers: {
                "Content-Type": "application/json",
            }
        }).then(res => {
            var data = res;
            setActivityData(data);
            setActivityDataFetched(true);
        });
    }

    const getNoteData = () => {
        var param = {
            AuditReviewId: auditReviewId
        }
        authenticatedFetch(
            "/Note/GetNotes", {
            method: "POST",
            body: JSON.stringify(param),
            headers: {
                "Content-Type": "application/json",
            }
        }).then(res => {
            var data = res;
            setNoteData(data);
            setNoteFetched(true);
        });
    }

    //Get back all the questions for this loan
    const getCheckListData = (loanId: any, auditPlanType: any) => {
        var param = {
            LoanId: loanId,
            AuditType: auditPlanType,
            AuditReviewId: auditReviewId
        }
        authenticatedFetch(
            "/Audit/getCheckListData", {
            method: "POST",
            body: JSON.stringify(param),
            headers: {
                "Content-Type": "application/json",
            }
        }).then(res => {
            
            var data = res;
            setchecklistData(data);
            getResponses(data);
            getResponsesForPDF();
        });
        
    }

    //Get back all the responses already made for this loan
    const getResponses = (checklistData: any) => {
        var param = {
            AuditReviewId: auditReviewId
        }
        authenticatedFetch(
            "/Audit/GetResponses", {
            method: "POST",
            body: JSON.stringify(param),
            headers: {
                "Content-Type": "application/json",
            }
        }).then(res => {
            var data = res;
            setAllResponses(data.Responses);
          

            //If there was a selected one, set it up again
            if (selectedChecklist != null && checklistData != null) {
                var newSelection = checklistData.checklists.filter((f: any) => f.Category == selectedChecklist.Category);
                console.log("Checking responses",newSelection);
                if (newSelection) {
                    getCheckListDetail(newSelection[0], data.Responses);
                }
            }

            
        });
    }

    // ==================== NEW FUNCTION: Get Responses for PDF Only ====================
const getResponsesForPDF = () => {
    var param = {
        AuditReviewId: auditReviewId
    }
    
    return authenticatedFetch(
        "/Audit/GetResponsesForPDF/GetResponsesForPDF", {  // ✅ NEW API endpoint
        method: "POST",
        body: JSON.stringify(param),
        headers: {
            "Content-Type": "application/json",
        }
    }).then(res => {
        var data = res;
        setPdfResponses(data.Responses);  // ✅ Separate state for PDF
        //console.log("Responses for PDF:", data.Responses);  // ✅ Log to verify
        return data.Responses;
    });
}

// ==================== MODIFIED: saveAllChecklistPdf ====================
// const saveAllChecklistPdf = async () => {  // ✅ Make it async
//     // ✅ FIRST: Fetch latest PDF data
//     await getResponsesForPDF();
    
//     // Wait a moment for state to update
//     setTimeout(() => {
//         generatePDF();
//     }, 100);
// }

    const getCheckListDetail = (item: any, responses: any) => {
        console.log("Getting checklist detail for", item);
      setSelectedChecklist(item);
      
            setActivePage("Checklist");
     
    }
    const editHeaderTemplate = (tabColor: string, options: any) => {
        const className = `${options.className} ${tabColor} justify-content-start  `;
        const titleClassName = `${options.titleClassName} ${tabColor} ml-2 `;
        const style = { fontSize: '1.25rem' };
        return (
            <div className={className}>
                <span className={titleClassName} style={style}>{options.props.header}</span>
                {/* {options.props.header} */}
            </div>
        );
    };

    const checklistHeaderTemplate = (tabColor: string, switchOn: boolean, options: any) => {
        const className = `${options.className} ${tabColor}`;
        const titleClassName = `${options.titleClassName} ${tabColor} ml-2 `;
        const style = { fontSize: '1.25rem' };
        return (
            <div className={className}>
                <span className={titleClassName} style={style}>{options.props.header}</span>
                {switchOn ?
                    <div className="flex flex-wrap justify-content-end gap-3">
                        <span>Show unaswered questions only</span>
                        <InputSwitch checked={checklistNoResponseOnly} onChange={() => setChecklistNoResponseOnly(!checklistNoResponseOnly)} />
                    </div>
                    : ""}
            </div>
        );
    };

    // Security to check if the user has any of the allowed roles.
    // NOTE: Keep below any react.js "use" items (i.e., useHook, useEffect, useState, useMemo, etc.)
    let { hasRoles, isLoading } = useHasRole(['Account Administrator', 'Account Manager', 'QC Admin', 'QC Manager', 'QC Auditor', 'QC Validator', 'System Administrator','Master Administrator'])

    //console.log("isLoading:", isLoading);
    if (isLoading) {
        return <Loading />
    }
    else if (!hasRoles) {
        return NotFound();
    }

    function page_Start() {
        return (
            <Panel header="Overview" headerTemplate={(o) => editHeaderTemplate('', o)} style={{ height: "100%" }}>
                <p>Activity goes here</p>
            </Panel>

        )
    }

    const Page_Notes = () => {
        return (
            <Panel header="Notes" headerTemplate={(o) => editHeaderTemplate('bg-ca-extended-4', o)} style={{ height: "77.5vh" }}>
                <ScrollPanel style={{ paddingTop: "20px", width: '100%', height: '67.5vh' }}>
                    {
                        noteData.map((data: any, i: number) => {
                            return (
                                <div className="mt-1 w-full">
                                    {i > 0 ? <Divider style={{ margin: "1rem 0" }} /> : ""}

                                    <span className="block note-display">{data.Note}</span>

                                    <span className="block font-italic mt-1">--{data.CreatedBy}, {data.CreatedDate}</span>
                                </div>
                            )
                        })
                    }
                </ScrollPanel>
            </Panel>
        )
    }

    function page_Attachment() {
        const path = `/Attachment/GetReviewAttachmentData?auditReviewAttachmentId=${selectedAttachment.AuditReviewAttachmentId}`;
        return (
            <Panel header={"Attachment View - " + selectedAttachment.FileName} headerTemplate={(o) => editHeaderTemplate('bg-ca-extended-5', o)} style={{ height: "77vh" }}>
                <div className="col-12">
                    <div className="formgrid grid">
                        <div className="field col">
                            <label>File Name</label><br />
                            <label>{selectedAttachment.FileName}</label>
                        </div>
                        <div className="field col">
                            <label>Date Added</label><br />
                            <label>{selectedAttachment.CreatedDate}</label>
                        </div>
                        <div className="field col">
                            <label>Added By</label><br />
                            <label>{selectedAttachment.CreatedBy}</label>
                        </div>
                        <div className='field col'>
                            <label>Comments</label><br />
                            <label>{selectedAttachment.Comment}</label>

                        </div>
                    </div>
                </div>
                {
                    selectedAttachment.FileType === "img" && <img src={path} height="100%" style={{ display: "block", marginLeft: "auto", marginRight: "auto", maxWidth: "100%" }}></img>
                }
                {
                    selectedAttachment.FileType === "pdf" &&
                    <div>
                        <ScrollPanel style={{ width: '100%', height: '60vh' }}>
                            <iframe src={path} style={{ border: "none", width: "100%", height: "100%" }}>

                            </iframe>
                        </ScrollPanel>
                    </div>
                }
                {
                    selectedAttachment.FileType === "txt" &&
                    <ScrollPanel style={{ width: '100%', height: '60vh' }}>
                        <iframe src={path} style={{ border: "none", width: "100%", height: "100%" }}>

                        </iframe>
                    </ScrollPanel>
                    // <object type="text/pain" data={selectedAttachment.path} width="100%" style={{ overflow: "hidden", minHeight: "66vh" }}></object>
                }

                {/* <object width="910" height="340" type="text/plain" data="message.txt" border="0"
   style="overflow: hidden;">
</object> */}

            </Panel>

        )
    }


    const Page_NewAttachment = () => {

        const [isUploading, setIsUploading] = useState<boolean>(false);
        const [comments, setComments] = useState<string>("")
console.log("Selected Attachment", selectedAttachment);
        const onSelect = (e: FileUploadSelectEvent) => {
            for (let i = 0; i < e.files.length; i++) {
                if ((e.files[i].type === "image/png") || (e.files[i].type === "text/csv")
                    || (e.files[i].type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") || (e.files[i].type === "image/jpeg")
                    || (e.files[i].type === "text/plain") || (e.files[i].type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document")) {

                } else {
                    toast.current?.show({ severity: 'warn', summary: 'Warning', detail: 'Attachment type is not supported. The following file types are allowed:  .txt, .pdf, .doc, .docx, .xls, .xlsx, .csv.', life: 3000 });
                    delete e.files[i];
                }
            }
        }

        const onUpload = (e: any) => {

            //this.toast.current.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded' });
            var result = JSON.parse(e.xhr.response);
            toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Attachment Successfuly Added', life: 3000 });
            getAttachmentData();
        };

        const onBeforeUpload = (e: FileUploadBeforeUploadEvent) => {
            setIsUploading(true);
            e.formData.append('AuditReviewId', auditReviewId!);
            e.formData.append('Comments', comments!);
        }

        return (
            <Panel header={"Upload New Attachment"} headerTemplate={(o) => editHeaderTemplate('bg-ca-extended-5', o)} style={{ height: "76vh" }}>
                {/* Change the url to correct URL for database */}
                <ProgressBar mode={isUploading ? "indeterminate" : "determinate"} style={{ height: '6px', borderRadius: '5px', margin: '1.2rem 0.6rem 0.2rem' }}></ProgressBar>
                <div className="col-12">
                    <span className='text-sm'>Allowed file types:  .txt, .pdf, .doc, .docx, .xls, .xlsx, .csv.</span>
                    <FileUpload onBeforeSend={onBeforeUpload} onSelect={onSelect} onUpload={onUpload}
                        name="UploadedFiles" url={"/Attachment/AddReviewAttachment"}
                        maxFileSize={10000000}
                        emptyTemplate={<p className="m-0">Drag and drop a file to here to upload.</p>}
                    // disabled={isInval id}
                    />
                </div>
                <div className="col-12 audit-plan">
                    <label className="block mb-2">Attachment Comments</label>
                    <InputTextarea value={comments} onChange={(e: any) => setComments(e.target.value)} rows={3} style={{ width: "100%", padding: "0px;" }} />
                </div>


            </Panel>

        )
    }


    const Page_Loan = (props: any) => {
        //Make copy of loan
        const [editLoanData, setEditLoan] = useState<any>();

        useEffect(() => {
            //Make copy
            var copyItem = JSON.parse(JSON.stringify(props.LoanData))

            //Add dummy items
            copyItem.Account = {};
            copyItem.CreatedBy = {};
            copyItem.LastModifiedBy = {};

            setEditLoan(copyItem);

        }, [props.LoanData])

        return (
             editLoanData && <Panel header={"Loan Detail - " + loanData.LoanName} headerTemplate={(o) => editHeaderTemplate('bg-ca-extended-1', o)} style={{ height: "fit-content" }}>
                <ScrollPanel style={{ paddingTop: "20px", width: '100%', height: '67.5vh' }}>
                    <div className="loan-form formgrid grid form" style={{ marginTop: "10px" }}>
                        <div className="form-column col-6">

                            <span className="p-float-label">
                                <InputText disabled id="LoanName" value={editLoanData.LoanName} />
                                <label htmlFor="LoanName">Loan Name</label>
                            </span>
                            <span className="p-float-label">
                                <InputText disabled id="LoanNumber" value={editLoanData.LoanNumber} />
                                <label htmlFor="loanNumber">Loan Number</label>
                            </span>

                            <span className="p-float-label">
                                <InputText disabled id="borrowersFirstName" value={editLoanData.BorrowersFirstName} onChange={(e) => { setEditLoan((s: any) => { return { ...s, BorrowersFirstName: e.target.value } }); }} />
                                <label htmlFor="borrowersFirstName">Borrowers First Name</label>
                            </span>

                            <span className="p-float-label">
                                <InputText disabled id="borrowersLastName" value={editLoanData.BorrowersLastName} />
                                <label htmlFor="borrowersLastName">Borrowers Last Name</label>
                            </span>

                            <span className="p-float-label">
                                <InputText disabled id="CurrentAddress" value={editLoanData.CurrentAddress} />
                                <label htmlFor="CurrentAddress">Current Address</label>
                            </span>


                            <span className="p-float-label">
                                <InputText disabled id="CurrentCity" value={editLoanData.CurrentCity} />
                                <label htmlFor="CurrentCity">Current City</label>
                            </span>


                            <span className="p-float-label">
                                <InputText disabled id="CurrentState" value={editLoanData.CurrentState} />
                                <label htmlFor="CurrentState">Current State</label>
                            </span>


                            <span className="p-float-label">
                                <InputText disabled id="CurrentZipCode" value={editLoanData.CurrentZipCode} />
                                <label htmlFor="CurrentZipCode">Current Zipcode</label>
                            </span>

                            {/* <span className="p-float-label">
                                <InputText disabled id="FundingDate" value={editLoanData.FundingDate} />
                                <label htmlFor="FundingDate">Funding Date</label>
                            </span> */}

                            {auditPlanType == "Prefund" &&  <span className="p-float-label">
                                <InputText disabled id="FundingDate" value={editLoanData.FundingDate} />
                                <label htmlFor="FundingDate">Funding Date</label>
                            </span>}
                              {auditPlanType == "Postclose" &&  <span className="p-float-label">
                                <InputText disabled id="Postclose" value={editLoanData.ClosingDate} />
                                <label htmlFor="Postclose">Closing Date</label>
                            </span>}
                             {auditPlanType == "Servicing" &&  <span className="p-float-label">
                                <InputText disabled id="Servicing" value={editLoanData.TransferDate} />
                                <label htmlFor="Servicing">Transfer Date</label>
                            </span>}
                             {/* <span className="p-float-label">
                                <InputText disabled id="TransferDate" value={editLoanData.TransferDate} />
                                <label htmlFor="TransferDate">Transfer Date</label>
                            </span> */}

                            <span className="p-float-label">
                                <InputText disabled id="fundingMonth" value={editLoanData.FundingMonth} />
                                <label htmlFor="fundingMonth">Funding Month</label>
                            </span>

                            <span className="p-float-label">
                                <InputText disabled id="LoanAmount" value={editLoanData.LoanAmount} />
                                <label htmlFor="LoanAmount">Loan Amount</label>
                            </span>

                            <span className="p-float-label">
                                <InputText disabled id="InterestRate" value={editLoanData.InterestRate} />
                                <label htmlFor="InterestRate">Interest Rate</label>
                            </span>
                            <span className="p-float-label">
                                <InputText disabled id="CreditScore" value={editLoanData.CreditScore} />
                                <label htmlFor="CreditScore">Credit Score</label>
                            </span>

                            <span className="p-float-label">
                                <InputText disabled id="InvestorType" value={editLoanData.InvestorType} />
                                <label htmlFor="InvestorType">Investor Type</label>
                            </span>
                            <span className="p-float-label">
                                <InputText disabled id="Investor" value={editLoanData.Investor} />
                                <label htmlFor="Investor">Investor</label>
                            </span>
                            <span className="p-float-label">
                                <InputText disabled id="InvestorName" value={editLoanData.InvestorName} />
                                <label htmlFor="InvestorName">Investor Name</label>
                            </span>

                            <span className="p-float-label">
                                <InputText id="LoanSelection" disabled value={editLoanData.LoanSelection}                                    
                                />
                                <label htmlFor="LoanSelection">Loan Selection</label>
                            </span>

                            <span className="p-float-label">
                                <InputText disabled id="CreatedDate" value={editLoanData.CreatedDate} />
                                <label htmlFor="CreatedDate">Created Date</label>
                            </span>

                            <span className="p-float-label">
                                <InputText disabled id="LastModifiedDate" value={editLoanData.LastModifiedDate} />
                                <label htmlFor="LastModifiedDate">Last Updated</label>
                            </span>
                        </div>

                        <div className="form-column col-6">

                            <span className="p-float-label">
                                <InputText disabled id="client" value={editLoanData.Client} />
                                <label htmlFor="client">Client</label>
                            </span>

                            <span className="p-float-label">
                                <InputText disabled id="AmortizationType" value={editLoanData.AmortizationType} />
                                <label htmlFor="AmortizationType">Amortization Type</label>
                            </span>

                            <span className="p-float-label">
                                <InputText disabled id="LoanType" value={editLoanData.LoanType} />
                                <label htmlFor="LoanType">Loan Type</label>
                            </span>

                            <span className="p-float-label">
                                <InputText disabled id="DocumentationType" value={editLoanData.DocumentationType} />
                                <label htmlFor="DocumentationType">Documentation Type</label>
                            </span>


                            <span className="p-float-label">
                                <InputText disabled id="LoanPurpose" value={editLoanData.LoanPurpose} />
                                <label htmlFor="LoanPurpose">Loan Purpose</label>
                            </span>


                            <span className="p-float-label">
                                <InputText disabled id="RefinanceType" value={editLoanData.RefinanceType} />
                                <label htmlFor="RefinanceType">Refinance Type</label>
                            </span>


                            <span className="p-float-label">
                                <InputText disabled id="LienPosition" value={editLoanData.LienPosition} />
                                <label htmlFor="LienPosition">Lien Position</label>
                            </span>


                            <span className="p-float-label">
                                <InputText disabled id="LoanType" value={editLoanData.LoanType} />
                                <label htmlFor="LoanType">Loan Type</label>
                            </span>

                            <span className="p-float-label">
                                <InputText disabled id="PropertyType" value={editLoanData.PropertyType} />
                                <label htmlFor="PropertyType">Property Type</label>
                            </span>
                            <span className="p-float-label">
                                <InputText disabled id="OccupancyType" value={editLoanData.OccupancyType} />
                                <label htmlFor="OccupancyType">Occupancy Type</label>
                            </span>

                            {auditPlanType == "Servicing" ? 
                            <>
                            <span className="p-float-label">
                    <InputText id="Dlqstatus" value={editLoanData.Dlqstatus}
                      disabled
                    />
                    <label htmlFor="Dlqstatus">Delinquent Status</label>
                </span>
                <span className="p-label">
                <label htmlFor="AccountStatus">Account Status</label>
                <InputText id="AccountFlags" value={editLoanData.AccountStatus}
                    disabled
                />

                </span>
                <span className="p-float-label">
                <InputText id="AccountFlags" value={editLoanData.AccountFlags}
                    disabled
                />
                <label htmlFor="AccountFlags">Account Flags</label>
                </span>


                <span className="p-float-label">
                <InputText id="EscrowPayment" value={editLoanData.EscrowPayment}
                    disabled
                />
                <label htmlFor="EscrowPayment">Escrow Payment</label>
                </span>


                <span className="p-float-label">
                <InputText id="EscrowAnalysisDate" value={editLoanData.EscrowAnalysisDate}
                    disabled
                />
                <label htmlFor="EscrowAnalysisDate">Escrow Analysis Date</label>
                </span>
                
                <span className="p-float-label">
                <InputText id="LastPaymentDate" value={editLoanData.LastPaymentDate}
                    disabled
                />
                <label htmlFor="LastPaymentDate">Last Payment Date</label>
                </span>
                
                <span className="p-float-label">
                <InputText id="NextDueDate" value={editLoanData.NextDueDate}
                   disabled
                />
                <label htmlFor="NextDueDate">Next Due Date</label>
                </span>
                
                <span className="p-float-label">
                <InputText id="ArmadjustmentDate" value={editLoanData.ArmadjustmentDate}
                    disabled                    
                />
                <label htmlFor="ArmadjustmentDate">ARM Adjustment Date</label>
                </span>
                            </>
                            
                            : 
                            <>
                            <span className="p-float-label">
                                <InputText disabled id="Ltv" value={editLoanData.Ltv} />
                                <label htmlFor="Ltv">LTV</label>
                            </span>
                            <span className="p-float-label">
                                <InputText disabled id="Cltv" value={editLoanData.Cltv} />
                                <label htmlFor="Cltv">CLTV</label>
                            </span>


                            <span className="p-float-label">
                                <InputText disabled id="LoanOfficer" value={editLoanData.LoanOfficer} />
                                <label htmlFor="LoanOfficer">Loan Officer</label>
                            </span>
                            <span className="p-float-label">
                                <InputText disabled id="Closer" value={editLoanData.Closer} />
                                <label htmlFor="Closer">Closer</label>
                            </span>

                            <span className="p-float-label">
                                <InputText disabled id="LoanProcessor" value={editLoanData.LoanProcessor} />
                                <label htmlFor="LoanProcessor">Loan Processor</label>
                            </span>
                            <span className="p-float-label">
                                <InputText disabled id="Underwriter" value={editLoanData.Underwriter} />
                                <label htmlFor="Underwriter">Underwriter</label>
                            </span>
                            <span className="p-float-label">
                                <InputText disabled id="MortgageOriginator" value={editLoanData.MortgageOriginator} />
                                <label htmlFor="MortgageOriginator">Mortgage Originator</label>
                            </span>
                            </>
                            }
                        </div>
                    </div>
                </ScrollPanel>
            </Panel>
        )
    }

    const updateResponseTally = () => {

        setQuestionLoading(true);
        var copy = { ...checklistData };
        //Recount this value
/*
        copy.totalAnswered = 0;
        //var allAnswers = 0;
        copy.checklists.forEach(
            (item: any) => {
                //Get all the checklist items
                let chkIds = item.Questions.map((i: any) => i.QcChecklistId);

                let totalAnswered = allResponses.filter(f => chkIds.indexOf(f.QcChecklistId) > -1 && f.Response);

                item.totalAnswered = totalAnswered.length;

                if (item.totalAnswered == item.totalItems) {
                    copy.totalAnswered += 1;
                }
            }
        )
*/
        setQuestionLoading(false);

        setchecklistData(copy);

    }


    const getLoanDetail = () => {
        setActivePage('Loan');
    }

    const getAttachmentDetail = (data: any) => {
        setSelectedAttachment(data);
        setActivePage('Attachment');
    }

    const getNewAttachment = () => {
        setActivePage('NewAttachment');
    }

    const getFindingDetail = (data: any) => {
        if (mode == "QC") {
            getFindingValidationData(data.AuditFindingId)
        }
        else {
            setSelectedAuditFinding(data);
            setActivePage('Finding');
        }
    }

    const Page_Finding = () => {

        // const [ReasonsForDecisionLookup, setReasonsForDecisionLookup] = useState<string[]>([]);
        // const [ReasonsForRevisionLookup, setReasonsForRevisionLookup] = useState<string[]>([]);
        // const [FindingStatusLookup, setFindingStatusLookup] = useState<string[]>([]);
        // const [QCStatusLookup, setQCStatusLookup] = useState<string[]>([]);
        const [showResponse, setShowResponse] = useState<boolean>(false);
     
        
        const [validationData, setValidationData] = useState<any>({
            Reason: "",
            Status: "",
            Comment: "",
            AuditFindingId: auditFindingId,
            Attachments: []
        });

        
        return (
            <Panel header={"Finding - " + selectedAuditFinding.RecordName} headerTemplate={(o) => editHeaderTemplate('bg-ca-extended-2', o)} style={{ height: "fit-content" }}  >
                <ScrollPanel style={{ paddingTop: "10px", width: '100%', height: '67.5vh' }}>
                    <div className="grid">
                        <div className="col-fixed" style={{ width: "30px" }}><Avatar label={selectedAuditFinding.CreatedBy2} style={{ color: 'white', backgroundColor: '#333' }} className="mr-2" />
                        </div>
                        <div className="col">

                            <div className="col-12 mb-2">
                                <label className="header-label block">QC Initial Finding Details</label>
                                <label className="block mt-1">{selectedAuditFinding.DefectDetail}</label>
                            </div>
                            <div className="col-12 mb-2">
                                <div className="formgrid grid">
                                    <div className="field col">
                                        <label className="header-label">Checklist Number</label><br />
                                        <label>{selectedAuditFinding.QuestionNumber}</label>
                                    </div>
                                    <div className="field col">
                                        <label className="header-label">Question</label><br />
                                        <label>{selectedAuditFinding.QuestionText}</label>
                                    </div>
                                    <div className="field col">
                                        <label className="header-label">QC by</label><br />
                                        <label>{selectedAuditFinding.CreatedBy}</label>
                                    </div>
                                </div>
                                <div className="formgrid grid">
                                    <div className="field col">
                                        <label className="header-label">{auditPlanType != "Servicing" ? "Defect Category" : "Source of Error"}</label><br />
                                        <label>{selectedAuditFinding.DefectCategory}</label>
                                    </div>
                                    <div className="field col">
                                        <label className="header-label">{auditPlanType != "Servicing" ? "Defect Subcategory" : "Error Type"}</label><br />
                                        <label>{selectedAuditFinding.DefectSubCategory}</label>
                                    </div>
                                    <div className="field col">
                                        <label className="header-label">{auditPlanType != "Servicing" ? "Defect Name" : "Is a CAP Required?"}</label><br />
                                        <label>{selectedAuditFinding.DefectName}</label>
                                    </div>
                                </div>
                                <div className="formgrid grid">
                                    <div className="field col-4">
                                        <label className="header-label">Severity</label><br />
                                        <label>{selectedAuditFinding.SeverityRating}</label>
                                    </div>
                                    <div className="field col-4">
                                        <label className="header-label">Area Responsible</label><br />
                                        <label>{selectedAuditFinding.AreaResponsible}</label>
                                    </div>

                                </div>
                                {
                                auditPlanType == "Servicing" &&  selectedAuditFinding.DefectName == "Yes" ? 
                                <div className="formgrid grid">
                                
                                <div className="field col-4">
                                <label className="header-label">Corrective Action Plan</label><br />
                                <label>{selectedAuditFinding.CAPActionPlan}</label>
                                </div>
                                <div className="field col-4">
                                <label className="header-label">CAP Implementation Date</label><br />
                                <label>{selectedAuditFinding.CAPImplementationDate}</label>
                                </div>
                                </div>                                                                                    
                                : ""  
                                }   
                            </div>
                        </div>
                    </div>

                    {
                        selectedAuditFinding.Validations.map((data: any) => {
                            return (
                                <div className="grid">
                                    <div className="col-fixed" style={{ width: "30px" }}><Avatar label={data.CreatedBy2} style={{ color: 'white', backgroundColor: data.ResponseFrom == "Validator" ? 'orange' : '#333' }} className="mr-2" /></div>
                                    <div className="col">
                                        <div className="col-12 mb-2">
                                            <label className="header-label">{data.ResponseFrom == "Validator" ? "Validator Response" : "QC Auditor Response"}</label><br />
                                            <div className="val-comments mt-1" dangerouslySetInnerHTML={{ __html: data.Comment }}></div>
                                        </div>
                                        {data.Attachments.length > 0 ?
                                            <div className="col-12 mb-2">
                                                <label className="header-label">Attachment(s)</label><br />
                                                {
                                                    data.Attachments.map((att: any) => {

                                                        return (
                                                            <div className="linkButton text-base" onClick={() => getAttachmentDetail(att)}>{att.FileName}</div>
                                                        )
                                                    }
                                                    )
                                                }
                                            </div>
                                            : ""}
                                        <div className="col-12 mb-2 grid">
                                            <div className="field col-3">
                                                <label className="header-label">Reason for Decision</label><br />
                                                <label>{data.Reason}</label>
                                            </div>
                                            <div className="field col-3">
                                                <label className="header-label">Updated Finding Status</label><br />
                                                <label>{data.Status}</label>
                                            </div>
                                            <div className="field col-3">
                                                <label className="header-label">{data.ResponseFrom == "Validator" ? "Validated" : "Responded"} On</label><br />
                                                <label>{data.CreatedDate}</label>
                                            </div>
                                            <div className="field col-3">
                                                <label className="header-label">{data.ResponseFrom == "Validator" ? "Validated" : "Responded"} By</label><br />
                                                <label>{data.CreatedBy}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    }



                </ScrollPanel>
            </Panel>
        )
    }

const Page_Questions=() => {
        //For all the defect related dropdown boxes
        const [checklistLoadingDone, setChecklistLoadingDone] = useState<boolean>(false);

        const [defectLookup, setDefectLookup] = useState<any[]>([]);

        //For maintaining the responses within a given checklist
        const [checklistResponse, setChecklistResponse] = useState<Record<string, any>>({});

        useEffect(() => {
            //Lookups
             initPage();
           
        }, []);
        const initPage = () => {
            var item = selectedChecklist;
            
            var matchQuestionResponse = item.Questions.map((x: any) => {
                var matches = allResponses.filter((f: any) => f.QcChecklistId == x.QcChecklistId);
                if (matches.length > 0) {
                    var resp = matches[0];
                    resp.QcChecklistId = x.QcChecklistId;

                    resp.saved = true;
                    resp.savedResponse = {
                        Response: resp.Response,
                        DefectName: resp.DefectName,
                        DefectCategory: resp.DefectCategory,
                        DefectSubCategory: resp.DefectSubCategory,
                        DefectDetail: resp.DefectDetail,
                        SeverityRating: resp.SeverityRating,
                        CAPActionPlan: resp.CAPActionPlan, 
                        CAPImplementationDate: resp.CAPImplementationDate

                    }
                    return resp
                }
                else {
                    //return an empty place
                    resp = {
                        QcChecklistId: x.QcChecklistId,
                        Response: "",
                        DefectCategory: "",
                        defecttSubCategory: "",
                        DefectName: "",
                        SeverityRating: "",
                        saved: false
                    }
                    return resp
                }
            });
            //let matchResponse = Object.fromEntries();

            let responseRecord: Record<string, any> = {};

            for (let item in matchQuestionResponse) {
                let row = matchQuestionResponse[item];
                responseRecord[row.QcChecklistId] = row;
                // Use `key` and `value`
            }

            setChecklistResponse(responseRecord);
           // ✅ STORE RESPONSES WITHOUT RE-RENDER
            //checkListedResponseRef.current = responseRecord;
            setChecklistLoadingDone(true);
             //console.log("responseRecord",responseRecord);
        }

       
 
        if (!checklistLoadingDone)
            return (<div>Loading Page</div>)

        return (
            <Panel header={"Checklist - " + selectedChecklist?.Category} headerTemplate={(o) =>selectedChecklist?.totalItems ? checklistHeaderTemplate('bg-ca-extended-6', false, o) : checklistHeaderTemplate('bg-ca-extended-3', true, o)}  >
                <ScrollPanel style={{ paddingTop: "10px", width: '100%', height: '67.5vh' }}>
                    {selectedChecklist?.Questions.map((q: any, i: number) => {
                        if (checklistNoResponseOnly && checklistResponse[q.QcChecklistId].saved && checklistResponse[q.QcChecklistId].Response)
                            return ""
                        else
                            return (
                                <div className="grid nested-grid">

                                    <div className="col-12">
                                        {i > 0 ? <Divider /> : ""}
                                        <div className='grid'>
                                            <div className="col-fixed text-primary font-bold" style={{ width: "30px" }}>
                                                {i + 1}.
                                            </div>
                                            <div className="col">
                                                <span className="text-primary font-bold">{q.QuestionText}</span>
                                                <p>

                                                    {checklistResponse[q.QcChecklistId]?.saved ?
                                                        (<div className="flex flex-wrap gap-4"><span className="col-12 mb-2">A: {checklistResponse[q.QcChecklistId].Response}</span></div>)
                                                        :
                                                        ""
                                                    }

                                                    {checklistResponse[q.QcChecklistId]?.Response === "Finding" ?
                                                        (
                                                            <div>
                                                                {checklistResponse[q.QcChecklistId]?.saved ?
                                                                    <div>
                                                                        <div className="col-12 mb-2">
                                                                            <label>{checklistResponse[q.QcChecklistId]?.DefectDetail}</label>
                                                                        </div>
                                                                        <div className="col-12 mb-2">
                                                                            <div className="formgrid grid">
                                                                                <div className="field col">
                                                                                    <label>Defect Category</label><br />
                                                                                    <label>{checklistResponse[q.QcChecklistId]?.DefectCategory}</label>
                                                                                </div>
                                                                                <div className="field col">
                                                                                    <label>Defect Subcategory</label><br />
                                                                                    <label>{checklistResponse[q.QcChecklistId]?.DefectSubCategory}</label>
                                                                                </div>
                                                                                <div className="field col">
                                                                                    <label>Defect Name</label><br />
                                                                                    <label>{checklistResponse[q.QcChecklistId]?.DefectName}</label>
                                                                                </div>
                                                                                <div className="field col">
                                                                                    <label>Severity</label><br />
                                                                                    <label>{checklistResponse[q.QcChecklistId]?.SeverityRating}</label>
                                                                                </div>
                                                                                <div className="field col">
                                                                                    <label>Area Responsible</label><br />
                                                                                    <label>{checklistResponse[q.QcChecklistId]?.AreaResponsible.AreaResponsibleName}</label>
                                                                                </div>
                                                                            {/* {checklistResponse[q.QcChecklistId]?.Validations?.length > 0 && (
                                                                                    <>
                                                                                    <div className="field col">
                                                                                    <label>Validator Response</label><br />
                                                                                    <label>{checklistResponse[q.QcChecklistId]?.Validations?.[0]?.Comment.replace(/<[^>]*>/g, "")}</label>
                                                                                </div>

                                                                                <div className="field col">
                                                                                    <label>Reason</label><br />
                                                                                    <label>{checklistResponse[q.QcChecklistId]?.Validations?.[0]?.Reason}</label>
                                                                                </div>


                                                                                <div className="field col">
                                                                                    <label>Updated By Finding Status</label><br />
                                                                                    <label>{checklistResponse[q.QcChecklistId]?.Validations?.[0]?.Status}</label>
                                                                                </div>


                                                                                <div className="field col">
                                                                                    <label>Validated On</label><br />
                                                                                    <label>{checklistResponse[q.QcChecklistId]?.Validations?.[0]?.CreatedDate}</label>
                                                                                </div>


                                                                                <div className="field col">
                                                                                    <label>Validated By</label><br />
                                                                                    <label>{checklistResponse[q.QcChecklistId]?.Validations?.[0]?.CreatedBy}</label>
                                                                                </div>
                                                                                

                                                                                {checklistResponse[q.QcChecklistId]?.Validations?.[0]?.Attachments?.map((file: any, i: number) => (
                                                                                    <div key={i} className="field col">
                                                                                        <b>Attachment {i + 1}</b><br />
                                                                                        File: {file.FileName}<br />
                                                                                        Added By: {file.CreatedBy || ""}<br />
                                                                                        Date: {file.CreatedDate ? new Date(file.CreatedDate).toLocaleDateString() : ""}<br />
                                                                                        Comment: {file.Comment || ""}
                                                                                    </div>
                                                                                    ))}
                                                                                </>
                                                                                )} */}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    ""
                                                                }

                                                            </div>

                                                        )
                                                        :
                                                        ""
                                                    }

                                                     


                                                </p>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                    })}
                </ScrollPanel>

                <div id="qc-print" style={{ display: "none", padding: "20px", fontFamily: "Arial" }}>
    <h2>Checklist - {selectedChecklist?.Category}</h2>

    {selectedChecklist?.Questions.map((q: any, i: number) => {
        const res = checklistResponse[q.QcChecklistId];

        return (
            <div key={q.QcChecklistId} style={{ marginBottom: "10px" }}>
                <div style={{ fontWeight: "bold" }}>
                    {i + 1}. {q.QuestionText}
                </div>

                <div style={{ marginLeft: "20px" }}>
                    A: {res?.Response || "No Response"}

                    {res?.Response === "Finding" && res?.saved && (
                        <div style={{ marginTop: "5px", marginLeft: "10px" }}>
                            <div>Defect Detail: {res.DefectDetail}</div>
                            <div>Defect Category: {res.DefectCategory}</div>
                            <div>Defect Subcategory: {res.DefectSubCategory}</div>
                            <div>Defect Name: {res.DefectName}</div>
                            <div>Severitye: {res.SeverityRating}</div>
                            <div>Area Responsible: {res.AreaResponsible?.AreaResponsibleName}</div>
                            

                            {/* ================= VALIDATIONS MAPPING ================= */}
                            {/* {res?.Validations?.length > 0 && (
                            <div style={{ marginTop: "10px", marginLeft: "10px", borderTop: "1px solid #ddd" }}>
                                <b>Validations:</b>

                                {res.Validations.map((v: any, index: number) => (
                                    <div key={index} style={{ marginTop: "5px" }}>
                                        <div>Response From: {v.ResponseFrom}</div>
                                        <div>Created By: {v.CreatedBy}</div>
                                        <div>Status: {v.Status}</div>
                                        <div>Reason: {v.Reason}</div>
                                        <div>Comment: <span dangerouslySetInnerHTML={{ __html: v.Comment }} /></div>

                                        {v.Attachments?.length > 0 && (
                                            <div>
                                                <b>Attachments:</b>
                                                {v.Attachments.map((a: any, i: number) => (
                                                    <div key={i}>📎 {a.FileName}</div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )} */}

                            {/* ================= END VALIDATIONS ================= */}
                        </div>
                    )}
                </div>
            </div>
        );
    })}
                    </div>


            </Panel>

        )
    }

const generatePDF  = () => {
    // ==================== VALIDATION ====================
    if (!checklistData?.checklists?.length) {
        alert("Checklist data not loaded");
        return;
    }

    // ==================== CONFIGURATION ====================
    const CONFIG = {
        PAGE: {
            width: 210, // A4 width in mm
            height: 297, // A4 height in mm
            margin: 15,
            contentWidth: 180, // 210 - (15 * 2)
        },
        FONTS: {
            title: 18,
            sectionHeader: 14,
            question: 11,
            body: 10,
            footer: 9,
        },
        COLORS: {
            primary: { r: 47, g: 111, b: 78 },
            secondary: { r: 70, g: 70, b: 70 },
            text: { r: 0, g: 0, b: 0 },
            lightGray: { r: 240, g: 240, b: 240 },
            white: { r: 255, g: 255, b: 255 },
        },
        SPACING: {
            lineHeight: 6,
            sectionGap: 10,
            questionGap: 8,
            defectGap: 4,
        },
    };
console.log("PDF pdfResponses:", pdfResponses);
    const pdfResponsesRef: Record<string, Record<string, any>> = {};
    
    checklistData?.checklists.forEach((category: any) => {
        const responseRecord: Record<string, any> = {};

        category.Questions.forEach((q: any) => {
            // ✅ Use pdfResponses instead of allResponses
            // const match = pdfResponses.find((r: any) => r.QcChecklistId === String(q.QcChecklistId));

            const match = pdfResponses.find((r: any) => 
    String(r.QcChecklistId) === String(q.QcChecklistId)
);
            if (match) {
                responseRecord[q.QcChecklistId] = { ...match, saved: true };
            } else {
                responseRecord[q.QcChecklistId] = {
                    QcChecklistId: q.QcChecklistId,
                    Response: "",
                    DefectCategory: "",
                    DefectSubCategory: "",
                    DefectName: "",
                    SeverityRating: "",
                    AreaResponsible: {},
                    Validations: [],  // ✅ Empty validations
                    saved: false
                };
            }
        });

        pdfResponsesRef[category.Category] = responseRecord;
        console.log(`Prepared responses for category`, pdfResponsesRef);
    });

    // ==================== DATA EXTRACTION ====================
    let QcCompleteDate: any = "";
    
    if (checklistData.checklists.length > 0) {
        for (const category of checklistData.checklists) {
            const responses = pdfResponsesRef[category.Category];  // ✅ Use pdfResponsesRef
            if (responses && Object.keys(responses).length > 0) {
                QcCompleteDate = responses[Object.keys(responses)[0]]?.QcCompleteDate || "";
                if (QcCompleteDate) break;
            }
        }
    }

    // ==================== PDF INITIALIZATION ====================
    const pdf = new jsPDF("p", "mm", "a4");
    let pageNumber = 1;
    let cursorY = CONFIG.PAGE.margin;

    // Placeholder for logo (add your base64 string here)
    const logoBase64 = '';

    // ==================== HELPER FUNCTIONS ====================

    /**
     * Adds a new page with consistent formatting
     */
    const addNewPage = () => {
        pdf.addPage();
        pageNumber++;
        cursorY = CONFIG.PAGE.margin;
        addWatermark();
        addPageNumber();
    };

    /**
     * Checks if content fits on current page, adds new page if needed
     */
    const checkPageBreak = (requiredSpace: number) => {
        if (cursorY + requiredSpace > CONFIG.PAGE.height - CONFIG.PAGE.margin - 10) {
            addNewPage();
            return true;
        }
        return false;
    };

    /**
     * Adds watermark to current page
     */
    const addWatermark = () => {
        pdf.setFontSize(50);
        pdf.setTextColor(CONFIG.COLORS.lightGray.r, CONFIG.COLORS.lightGray.g, CONFIG.COLORS.lightGray.b);
        // pdf.text("loanDNA", CONFIG.PAGE.width / 2, CONFIG.PAGE.height / 2, {
        //     align: "center",
        //     angle: 45,
        // });
        pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
    };

    /**
     * Adds page number at bottom
     */
    const addPageNumber = () => {
        pdf.setFontSize(CONFIG.FONTS.footer);
        pdf.setTextColor(CONFIG.COLORS.secondary.r, CONFIG.COLORS.secondary.g, CONFIG.COLORS.secondary.b);
        pdf.text(
            `Page ${pageNumber}`,
            CONFIG.PAGE.width / 2,
            CONFIG.PAGE.height - CONFIG.PAGE.margin + 5,
            { align: "center" }
        );
        pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
    };

   const drawSeparator = (y: number, fullWidth: boolean = true) => {
    pdf.setLineWidth(0.5);
    pdf.setDrawColor(CONFIG.COLORS.lightGray.r, CONFIG.COLORS.lightGray.g, CONFIG.COLORS.lightGray.b);
    const lineWidth = fullWidth ? CONFIG.PAGE.contentWidth : CONFIG.PAGE.contentWidth - 10;
    const startX = fullWidth ? CONFIG.PAGE.margin : CONFIG.PAGE.margin + 5;
    pdf.line(startX, y, startX + lineWidth, y);
};

/**
 * Renders multi-line text with proper wrapping
 */
const renderWrappedText = (
    text: string,
    x: number,
    fontSize: number,
    maxWidth: number,
    isBold: boolean = false
): number => {
    pdf.setFontSize(fontSize);
    pdf.setFont("helvetica", isBold ? "bold" : "normal");
    const lines = pdf.splitTextToSize(text, maxWidth);
    lines.forEach((line: string) => {
        pdf.text(line, x, cursorY);
        cursorY += CONFIG.SPACING.lineHeight;
    });
    return lines.length;
};

// ==================== HEADER SECTION (DYNAMIC ALIGNMENT) ====================
const renderHeader = () => {
    // Logo (if available)
    if (logoBase64) {
        const logoWidth = 50;
        const logoHeight = 12;
        const logoX = CONFIG.PAGE.width - CONFIG.PAGE.margin - logoWidth;
        const logoY = CONFIG.PAGE.margin;
        pdf.addImage(logoBase64, "PNG", logoX, logoY, logoWidth, logoHeight);
    }

    cursorY += 5;

    // Title
    pdf.setFontSize(CONFIG.FONTS.title);
    pdf.setFont("helvetica", "bold");
    pdf.setTextColor(CONFIG.COLORS.primary.r, CONFIG.COLORS.primary.g, CONFIG.COLORS.primary.b);
    pdf.text("QC Checklist Report", CONFIG.PAGE.width / 2, cursorY, { align: "center" });
    cursorY += 10;

    pdf.setFontSize(CONFIG.FONTS.title -6);
    pdf.setFont("helvetica", "normal");
    //pdf.setTextColor(CONFIG.COLORS.primary.r, CONFIG.COLORS.primary.g, CONFIG.COLORS.primary.b);
    pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
    pdf.text(`Loan Number-${loanData?.LoanNumber || "N/A"}`, CONFIG.PAGE.width / 2, cursorY, { align: "center" });
    cursorY += 4;

    // Separator line
    drawSeparator(cursorY);
    cursorY += 8;

    // Borrower Information Table
    const tableStartY = cursorY;
    const tableWidth = CONFIG.PAGE.contentWidth;
    const colWidth = tableWidth / 2;
    
    // Define rows - Property Address takes 2 rows
    const row1Height = 10;
    const row2Height = 10;
    const row3Height = 10;
    const totalHeight = row1Height + row2Height + row3Height;
    
    // Draw outer table border
    pdf.setDrawColor(180, 180, 180);
    pdf.setLineWidth(0.5);
    pdf.rect(CONFIG.PAGE.margin, tableStartY, tableWidth, totalHeight, "S");
    
    // Draw vertical line between columns
    pdf.line(
        CONFIG.PAGE.margin + colWidth,
        tableStartY,
        CONFIG.PAGE.margin + colWidth,
        tableStartY + totalHeight
    );
    
    // Draw horizontal lines
    // Line after row 1
    pdf.line(
        CONFIG.PAGE.margin,
        tableStartY + row1Height,
        CONFIG.PAGE.margin + tableWidth,
        tableStartY + row1Height
    );
    
    
    // Line after row 2 (only for right column - between Loan Type and Audit Completion Date)
    pdf.line(
        CONFIG.PAGE.margin + colWidth,
        tableStartY + row1Height + row2Height,
        CONFIG.PAGE.margin + tableWidth,
        tableStartY + row1Height + row2Height
    );
    
    // Set font for content
    pdf.setFontSize(CONFIG.FONTS.body);
    pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
    
    const leftX = CONFIG.PAGE.margin + 3;
    const rightX = CONFIG.PAGE.margin + colWidth + 3;
    
    // Calculate dynamic label widths based on actual text
    pdf.setFont("helvetica", "bold");
    const borrowerNameLabelWidth = pdf.getTextWidth("Borrower Name:");
    const propertyAddressLabelWidth = pdf.getTextWidth("Property Address:");
    // const loanNumberLabelWidth = pdf.getTextWidth("Loan Number:");
    const auditPlanTypeLabelWidth = pdf.getTextWidth("Audit Plan Type:");
    const loanTypeLabelWidth = pdf.getTextWidth("Loan Type:");
    const auditCompletionDateLabelWidth = pdf.getTextWidth("Audit Completion Date:");
    
    // Define consistent spacing after labels
    const labelSpacing = 2;
    
    // ROW 1: Borrower Name | Audit Plan Type
    let rowY = tableStartY + 6.5;
    
    pdf.setFont("helvetica", "bold");
    pdf.text("Borrower Name:", leftX, rowY);
    pdf.setFont("helvetica", "normal");
    pdf.text(loanData?.BorrowersFirstName || "N/A", leftX + borrowerNameLabelWidth + labelSpacing, rowY);

    // pdf.setFont("helvetica", "bold");
    // pdf.text("Loan Number:", rightX, rowY);
    // pdf.setFont("helvetica", "normal");
    // pdf.text(loanData?.LoanNumber || "N/A", rightX + loanNumberLabelWidth + labelSpacing, rowY);
    
    // ROW 2: Property Address | Loan Type
    //rowY = tableStartY + row1Height + 6.5;
    
    pdf.setFont("helvetica", "bold");
    pdf.text("Audit Plan Type:", rightX, rowY);
    pdf.setFont("helvetica", "normal");
    pdf.text(auditPlanType || "N/A", rightX + auditPlanTypeLabelWidth + labelSpacing, rowY);
    
    // ROW 2: Property Address | Loan Type
    rowY = tableStartY + row1Height + 6.5;
    
    pdf.setFont("helvetica", "bold");
    pdf.text("Property Address:", leftX, rowY);
    
    pdf.setFont("helvetica", "normal");
    const address = `${loanData?.CurrentAddress || ""}, ${loanData?.CurrentCity || ""}, ${loanData?.CurrentState || ""} ${loanData?.CurrentZipCode || ""}`;
    const maxAddressWidth = colWidth - propertyAddressLabelWidth - labelSpacing - 6;
    const addressLines = pdf.splitTextToSize(address, maxAddressWidth);
    
    addressLines.forEach((line: string, idx: number) => {
        pdf.text(line, leftX + propertyAddressLabelWidth + labelSpacing, rowY + (idx * 4.5));
    });
    
    // Right column - Loan Type (aligned to top of this row)
    pdf.setFont("helvetica", "bold");
    pdf.text("Loan Type:", rightX, rowY);
    pdf.setFont("helvetica", "normal");
    pdf.text(loanData?.LoanType || "N/A", rightX + loanTypeLabelWidth + labelSpacing, rowY);
    
    // ROW 3: Empty | Audit Completion Date
    rowY = tableStartY + row1Height + row2Height + 6.5;
    
    pdf.setFont("helvetica", "bold");
    pdf.text("Audit Completion Date:", rightX, rowY);
    pdf.setFont("helvetica", "normal");
    pdf.text(QcCompleteDate || "N/A", rightX + auditCompletionDateLabelWidth + labelSpacing, rowY);
    
    cursorY = tableStartY + totalHeight + CONFIG.SPACING.sectionGap;
};



// ==================== CATEGORY SECTION ====================
const renderCategory = (categoryName: string) => {
    checkPageBreak(15);

    // Category Header with background
    pdf.setFillColor(CONFIG.COLORS.primary.r, CONFIG.COLORS.primary.g, CONFIG.COLORS.primary.b);
    pdf.rect(CONFIG.PAGE.margin, cursorY, CONFIG.PAGE.contentWidth, 10, "F");
    
    pdf.setFontSize(CONFIG.FONTS.sectionHeader);
    pdf.setFont("helvetica", "bold");
    pdf.setTextColor(CONFIG.COLORS.white.r, CONFIG.COLORS.white.g, CONFIG.COLORS.white.b);
    pdf.text(categoryName, CONFIG.PAGE.margin + 3, cursorY + 7);
    
    pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
    cursorY += 14;
};

// ==================== QUESTION SECTION (NO TABLE - FIXED SPACING) ====================
const renderQuestion = (questionNum: number, questionText: string, response: any) => {
    // Calculate space needed for question
    const qLines = pdf.splitTextToSize(
        questionText,
        CONFIG.PAGE.contentWidth - 20
    );
    
    let spaceNeeded = (qLines.length) * CONFIG.SPACING.lineHeight + 15;
    
    // Add space for defect details if present
    if (response?.Response === "Finding") {
        spaceNeeded += 100;
    }

    checkPageBreak(spaceNeeded);

    // Question Number and Text
    pdf.setFontSize(CONFIG.FONTS.question);
    pdf.setFont("helvetica", "bold");
    pdf.setTextColor(CONFIG.COLORS.primary.r, CONFIG.COLORS.primary.g, CONFIG.COLORS.primary.b);
    
    // ✅ FIXED: Calculate dynamic width for question number
    const questionLabel = `Q${questionNum}:`;
    const questionLabelWidth = pdf.getTextWidth(questionLabel);
    pdf.text(questionLabel, CONFIG.PAGE.margin + 2, cursorY);
    
    pdf.setFont("helvetica", "normal");
    pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
    
    // ✅ FIXED: Start question text after the question number with proper spacing
    const questionTextStartX = CONFIG.PAGE.margin + 2 + questionLabelWidth + 3;
    const questionMaxWidth = CONFIG.PAGE.contentWidth - (questionTextStartX - CONFIG.PAGE.margin);
    const questionOnlyText = pdf.splitTextToSize(questionText, questionMaxWidth);
    
    questionOnlyText.forEach((line: string) => {
        pdf.text(line, questionTextStartX, cursorY);
        cursorY += CONFIG.SPACING.lineHeight;
    });

    cursorY += 2;

    // Answer (No Table Format - MINIMAL SPACING)
    pdf.setFontSize(CONFIG.FONTS.body);
    pdf.setFont("helvetica", "bold");
    pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
    
    const answerLabelWidth = pdf.getTextWidth("Answer:");
    pdf.text("Answer:", CONFIG.PAGE.margin + 5, cursorY);
    
    pdf.setFont("helvetica", "normal");
    const answerText = response?.Response || "No Response";
    const answerColor = response?.Response === "Finding" ? { r: 200, g: 50, b: 50 } : { r: 0, g: 0, b: 0 };
    pdf.setTextColor(answerColor.r, answerColor.g, answerColor.b);
    pdf.text(answerText, CONFIG.PAGE.margin + 5 + answerLabelWidth + 2, cursorY);
    pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
    
    // FIXED: Only add minimal spacing after answer
    cursorY += CONFIG.SPACING.lineHeight;

    // Render Defect Details if Finding
    if (response?.Response === "Finding") {
        renderDefectDetails(response);
    } else {
        // For non-Finding answers, add minimal gap before separator
        cursorY += 2;
    }

    // Separator and gap
    drawSeparator(cursorY, false);
    cursorY += CONFIG.SPACING.questionGap;
};

const renderDefectDetails = (response: any) => {
    cursorY += 2;
    
    // Defect Details Header
    pdf.setFillColor(252, 245, 245);
    pdf.rect(CONFIG.PAGE.margin + 5, cursorY, CONFIG.PAGE.contentWidth - 10, 8, "F");
    
    pdf.setFontSize(CONFIG.FONTS.question);
    pdf.setFont("helvetica", "bold");
    pdf.setTextColor(180, 50, 50);
    pdf.text("Defect Details", CONFIG.PAGE.margin + 8, cursorY + 5.5);
    pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
    cursorY += 10;

    // Defect Information Table
    const tableStartY = cursorY;
    const tableWidth = CONFIG.PAGE.contentWidth - 10;
    const labelColWidth = 40;
    const valueColWidth = tableWidth - labelColWidth;
    const rowHeight = 7;
    
    const defectFields = [
        { label: "Category", value: response.DefectCategory || "" },
        { label: "Subcategory", value: response.DefectSubCategory || "" },
        { label: "Defect Name", value: response.DefectName || "" },
        { label: "Severity", value: response.SeverityRating || "" },
        { label: "Area Responsible", value: response.AreaResponsible?.AreaResponsibleName || "" },
        { label: "Detail", value: response.DefectDetail || "" },
    ];

    pdf.setFontSize(CONFIG.FONTS.body - 1);
    pdf.setDrawColor(200, 200, 200);
    
    defectFields.forEach((field, idx) => {
        checkPageBreak(15);
        
        const rowY = cursorY;
        
        // Background color (alternating)
        if (idx % 2 === 0) {
            pdf.setFillColor(250, 250, 250);
        } else {
            pdf.setFillColor(255, 255, 255);
        }
        
        // Calculate required height based on text wrapping
        const maxValueWidth = valueColWidth - 4;
        const valueLines = pdf.splitTextToSize(field.value, maxValueWidth);
        const actualRowHeight = Math.max(rowHeight, valueLines.length * 4.5 + 2);
        
        // Draw background
        pdf.rect(CONFIG.PAGE.margin + 5, rowY, tableWidth, actualRowHeight, "F");
        
        // Row border
        pdf.rect(CONFIG.PAGE.margin + 5, rowY, tableWidth, actualRowHeight, "S");
        
        // Vertical line between columns
        pdf.line(
            CONFIG.PAGE.margin + 5 + labelColWidth, 
            rowY, 
            CONFIG.PAGE.margin + 5 + labelColWidth, 
            rowY + actualRowHeight
        );
        
        // Label (bold)
        pdf.setFont("helvetica", "bold");
        pdf.setTextColor(60, 60, 60);
        pdf.text(field.label, CONFIG.PAGE.margin + 7, rowY + 4.5);
        
        // Value (normal)
        pdf.setFont("helvetica", "normal");
        pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
        
        // Render multi-line values
        valueLines.forEach((line: string, lineIdx: number) => {
            pdf.text(line, CONFIG.PAGE.margin + 7 + labelColWidth, rowY + 4.5 + (lineIdx * 4.5));
        });
        
        cursorY += actualRowHeight;
    });

    // Validations Table - ALIGNED WITH DEFECT DETAILS
    if (response.Validations && response.Validations.length > 0) {
        cursorY += 6;
        checkPageBreak(20);
        
        // Validation Header (same alignment as Defect Details Header)
        pdf.setFillColor(245, 245, 250);
        pdf.rect(CONFIG.PAGE.margin + 5, cursorY, tableWidth, 8, "F");
        
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(CONFIG.FONTS.body);
        pdf.setTextColor(60, 60, 120);
        pdf.text("Validations", CONFIG.PAGE.margin + 8, cursorY + 5.5);
        cursorY += 10;

        response.Validations.forEach((val: any, valIdx: number) => {
            checkPageBreak(40);
            
            const validationFields = [
                { label: "Comment", value: val.Comment?.replace(/<[^>]*>/g, "") || "" },
                { label: "Reason", value: val.Reason || "" },
                { label: "Status", value: val.Status || "" },
                { label: "Validated On", value: val.CreatedDate || "" },
                { label: "Created By", value: val.CreatedBy || val.CreatedBy2 || "" },
            ];

            pdf.setFontSize(CONFIG.FONTS.body - 1);
            
            validationFields.forEach((vField, vIdx) => {
                if (vField.value) {
                    checkPageBreak(12);
                    
                    const vRowY = cursorY;
                    
                    // Calculate required height
                    const vMaxWidth = valueColWidth - 4;
                    const vValueLines = pdf.splitTextToSize(vField.value, vMaxWidth);
                    const vActualRowHeight = Math.max(rowHeight, vValueLines.length * 4.5 + 2);
                    
                    // Alternating background
                    if (vIdx % 2 === 0) {
                        pdf.setFillColor(252, 252, 252);
                    } else {
                        pdf.setFillColor(255, 255, 255);
                    }
                    
                    // ✅ FIXED: Same alignment as defect table (CONFIG.PAGE.margin + 5)
                    pdf.rect(CONFIG.PAGE.margin + 5, vRowY, tableWidth, vActualRowHeight, "F");
                    
                    // Row border
                    pdf.setDrawColor(200, 200, 200);
                    pdf.rect(CONFIG.PAGE.margin + 5, vRowY, tableWidth, vActualRowHeight, "S");
                    
                    // Vertical line
                    pdf.line(
                        CONFIG.PAGE.margin + 5 + labelColWidth, 
                        vRowY, 
                        CONFIG.PAGE.margin + 5 + labelColWidth, 
                        vRowY + vActualRowHeight
                    );
                    
                    // Label - ✅ FIXED: Same alignment (CONFIG.PAGE.margin + 7)
                    pdf.setFont("helvetica", "bold");
                    pdf.setTextColor(60, 60, 60);
                    pdf.text(vField.label, CONFIG.PAGE.margin + 7, vRowY + 4.5);
                    
                    // Value - ✅ FIXED: Same alignment (CONFIG.PAGE.margin + 7 + labelColWidth)
                    pdf.setFont("helvetica", "normal");
                    pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
                    
                    vValueLines.forEach((line: string, lineIdx: number) => {
                        pdf.text(line, CONFIG.PAGE.margin + 7 + labelColWidth, vRowY + 4.5 + (lineIdx * 4.5));
                    });
                    
                    cursorY += vActualRowHeight;
                }
            });

            // Attachments - ✅ FIXED: Aligned with validation table
            if (val.Attachments && val.Attachments.length > 0) {
                cursorY += 3;
                checkPageBreak(15);
                
                pdf.setFont("helvetica", "bold");
                pdf.setFontSize(CONFIG.FONTS.body - 1);
                pdf.setTextColor(60, 60, 60);
                pdf.text("Attachments:", CONFIG.PAGE.margin + 7, cursorY);
                cursorY += 5;

                val.Attachments.forEach((att: any) => {
                    checkPageBreak(10);
                    
                    pdf.setFont("helvetica", "normal");
                    pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
                    pdf.text(`• ${att.FileName || "Unnamed"}`, CONFIG.PAGE.margin + 10, cursorY);
                    cursorY += 4;
                    
                    if (att.Comment) {
                        pdf.setFont("helvetica", "italic");
                        pdf.setFontSize(CONFIG.FONTS.body - 2);
                        const commentLines = pdf.splitTextToSize(`  ${att.Comment}`, tableWidth - 15);
                        commentLines.forEach((line: string) => {
                            pdf.text(line, CONFIG.PAGE.margin + 12, cursorY);
                            cursorY += 4;
                        });
                        pdf.setFontSize(CONFIG.FONTS.body - 1);
                    }
                });
            }

            cursorY += 5;
        });
    }

    cursorY += 4;
};

// ==================== MAIN RENDERING ====================
addWatermark();
renderHeader();
addPageNumber();

// Iterate through categories and questions
checklistData.checklists.forEach((category: any) => {
        const responses = pdfResponsesRef[category.Category];
        if (!responses) return;

        renderCategory(category.Category);

        category.Questions.forEach((question: any, index: number) => {
            const response = responses[question.QcChecklistId];
            if (!response) return;

            renderQuestion(index + 1, question.QuestionText, response);
        });
    });

// ==================== SAVE PDF ====================
const fileName = `QC_Checklist_Report_${new Date().toISOString().split('T')[0]}.pdf`;
pdf.save(fileName);
};


// const generatePDF  = () => {
//     // ==================== VALIDATION ====================
//     if (!checklistData?.checklists?.length) {
//         alert("Checklist data not loaded");
//         return;
//     }

//     // ==================== CONFIGURATION ====================
//     const CONFIG = {
//         PAGE: {
//             width: 210, // A4 width in mm
//             height: 297, // A4 height in mm
//             margin: 15,
//             contentWidth: 180, // 210 - (15 * 2)
//         },
//         FONTS: {
//             title: 18,
//             sectionHeader: 14,
//             question: 11,
//             body: 10,
//             footer: 9,
//         },
//         COLORS: {
//             primary: { r: 47, g: 111, b: 78 },
//             secondary: { r: 70, g: 70, b: 70 },
//             text: { r: 0, g: 0, b: 0 },
//             lightGray: { r: 240, g: 240, b: 240 },
//             white: { r: 255, g: 255, b: 255 },
//         },
//         SPACING: {
//             lineHeight: 6,
//             sectionGap: 10,
//             questionGap: 8,
//             defectGap: 4,
//         },
//     };

//     // ==================== DATA EXTRACTION ====================
//     let QcCompleteDate: any = "";
    
//     if (checklistData.checklists.length > 0) {
//         for (const category of checklistData.checklists) {
//             const responses = allChecklistsResponsesRef.current[category.Category];
//             if (responses && Object.keys(responses).length > 0) {
//                 QcCompleteDate = responses[Object.keys(responses)[0]]?.QcCompleteDate || "";
//                 if (QcCompleteDate) break;
//             }
//         }
//     }

//     // ==================== PDF INITIALIZATION ====================
//     const pdf = new jsPDF("p", "mm", "a4");
//     let pageNumber = 1;
//     let cursorY = CONFIG.PAGE.margin;

//     // Placeholder for logo (add your base64 string here)
//     const logoBase64 = '';

//     // ==================== HELPER FUNCTIONS ====================

//     /**
//      * Adds a new page with consistent formatting
//      */
//     const addNewPage = () => {
//         pdf.addPage();
//         pageNumber++;
//         cursorY = CONFIG.PAGE.margin;
//         addWatermark();
//         addPageNumber();
//     };

//     /**
//      * Checks if content fits on current page, adds new page if needed
//      */
//     const checkPageBreak = (requiredSpace: number) => {
//         if (cursorY + requiredSpace > CONFIG.PAGE.height - CONFIG.PAGE.margin - 10) {
//             addNewPage();
//             return true;
//         }
//         return false;
//     };

//     /**
//      * Adds watermark to current page
//      */
//     const addWatermark = () => {
//         pdf.setFontSize(50);
//         pdf.setTextColor(CONFIG.COLORS.lightGray.r, CONFIG.COLORS.lightGray.g, CONFIG.COLORS.lightGray.b);
//         // pdf.text("loanDNA", CONFIG.PAGE.width / 2, CONFIG.PAGE.height / 2, {
//         //     align: "center",
//         //     angle: 45,
//         // });
//         pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
//     };

//     /**
//      * Adds page number at bottom
//      */
//     const addPageNumber = () => {
//         pdf.setFontSize(CONFIG.FONTS.footer);
//         pdf.setTextColor(CONFIG.COLORS.secondary.r, CONFIG.COLORS.secondary.g, CONFIG.COLORS.secondary.b);
//         pdf.text(
//             `Page ${pageNumber}`,
//             CONFIG.PAGE.width / 2,
//             CONFIG.PAGE.height - CONFIG.PAGE.margin + 5,
//             { align: "center" }
//         );
//         pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
//     };

//    const drawSeparator = (y: number, fullWidth: boolean = true) => {
//     pdf.setLineWidth(0.5);
//     pdf.setDrawColor(CONFIG.COLORS.lightGray.r, CONFIG.COLORS.lightGray.g, CONFIG.COLORS.lightGray.b);
//     const lineWidth = fullWidth ? CONFIG.PAGE.contentWidth : CONFIG.PAGE.contentWidth - 10;
//     const startX = fullWidth ? CONFIG.PAGE.margin : CONFIG.PAGE.margin + 5;
//     pdf.line(startX, y, startX + lineWidth, y);
// };

// /**
//  * Renders multi-line text with proper wrapping
//  */
// const renderWrappedText = (
//     text: string,
//     x: number,
//     fontSize: number,
//     maxWidth: number,
//     isBold: boolean = false
// ): number => {
//     pdf.setFontSize(fontSize);
//     pdf.setFont("helvetica", isBold ? "bold" : "normal");
//     const lines = pdf.splitTextToSize(text, maxWidth);
//     lines.forEach((line: string) => {
//         pdf.text(line, x, cursorY);
//         cursorY += CONFIG.SPACING.lineHeight;
//     });
//     return lines.length;
// };

// // ==================== HEADER SECTION (DYNAMIC ALIGNMENT) ====================
// const renderHeader = () => {
//     // Logo (if available)
//     if (logoBase64) {
//         const logoWidth = 50;
//         const logoHeight = 12;
//         const logoX = CONFIG.PAGE.width - CONFIG.PAGE.margin - logoWidth;
//         const logoY = CONFIG.PAGE.margin;
//         pdf.addImage(logoBase64, "PNG", logoX, logoY, logoWidth, logoHeight);
//     }

//     cursorY += 5;

//     // Title
//     pdf.setFontSize(CONFIG.FONTS.title);
//     pdf.setFont("helvetica", "bold");
//     pdf.setTextColor(CONFIG.COLORS.primary.r, CONFIG.COLORS.primary.g, CONFIG.COLORS.primary.b);
//     pdf.text("QC Checklist Report", CONFIG.PAGE.width / 2, cursorY, { align: "center" });
//     cursorY += 10;

//     pdf.setFontSize(CONFIG.FONTS.title -6);
//     pdf.setFont("helvetica", "normal");
//     //pdf.setTextColor(CONFIG.COLORS.primary.r, CONFIG.COLORS.primary.g, CONFIG.COLORS.primary.b);
//     pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
//     pdf.text(`Loan Number-${loanData?.LoanNumber || "N/A"}`, CONFIG.PAGE.width / 2, cursorY, { align: "center" });
//     cursorY += 4;

//     // Separator line
//     drawSeparator(cursorY);
//     cursorY += 8;

//     // Borrower Information Table
//     const tableStartY = cursorY;
//     const tableWidth = CONFIG.PAGE.contentWidth;
//     const colWidth = tableWidth / 2;
    
//     // Define rows - Property Address takes 2 rows
//     const row1Height = 10;
//     const row2Height = 10;
//     const row3Height = 10;
//     const totalHeight = row1Height + row2Height + row3Height;
    
//     // Draw outer table border
//     pdf.setDrawColor(180, 180, 180);
//     pdf.setLineWidth(0.5);
//     pdf.rect(CONFIG.PAGE.margin, tableStartY, tableWidth, totalHeight, "S");
    
//     // Draw vertical line between columns
//     pdf.line(
//         CONFIG.PAGE.margin + colWidth,
//         tableStartY,
//         CONFIG.PAGE.margin + colWidth,
//         tableStartY + totalHeight
//     );
    
//     // Draw horizontal lines
//     // Line after row 1
//     pdf.line(
//         CONFIG.PAGE.margin,
//         tableStartY + row1Height,
//         CONFIG.PAGE.margin + tableWidth,
//         tableStartY + row1Height
//     );
    
//     // Line after row 2 for left column (end of property address)
//     // pdf.line(
//     //     CONFIG.PAGE.margin,
//     //     tableStartY + row1Height + row2Height,
//     //     CONFIG.PAGE.margin + colWidth,
//     //     tableStartY + row1Height + row2Height
//     // );
    
//     // Line after row 2 (only for right column - between Loan Type and Audit Completion Date)
//     pdf.line(
//         CONFIG.PAGE.margin + colWidth,
//         tableStartY + row1Height + row2Height,
//         CONFIG.PAGE.margin + tableWidth,
//         tableStartY + row1Height + row2Height
//     );
    
//     // Set font for content
//     pdf.setFontSize(CONFIG.FONTS.body);
//     pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
    
//     const leftX = CONFIG.PAGE.margin + 3;
//     const rightX = CONFIG.PAGE.margin + colWidth + 3;
    
//     // Calculate dynamic label widths based on actual text
//     pdf.setFont("helvetica", "bold");
//     const borrowerNameLabelWidth = pdf.getTextWidth("Borrower Name:");
//     const propertyAddressLabelWidth = pdf.getTextWidth("Property Address:");
//     // const loanNumberLabelWidth = pdf.getTextWidth("Loan Number:");
//     const auditPlanTypeLabelWidth = pdf.getTextWidth("Audit Plan Type:");
//     const loanTypeLabelWidth = pdf.getTextWidth("Loan Type:");
//     const auditCompletionDateLabelWidth = pdf.getTextWidth("Audit Completion Date:");
    
//     // Define consistent spacing after labels
//     const labelSpacing = 2;
    
//     // ROW 1: Borrower Name | Audit Plan Type
//     let rowY = tableStartY + 6.5;
    
//     pdf.setFont("helvetica", "bold");
//     pdf.text("Borrower Name:", leftX, rowY);
//     pdf.setFont("helvetica", "normal");
//     pdf.text(loanData?.BorrowersFirstName || "N/A", leftX + borrowerNameLabelWidth + labelSpacing, rowY);

//     // pdf.setFont("helvetica", "bold");
//     // pdf.text("Loan Number:", rightX, rowY);
//     // pdf.setFont("helvetica", "normal");
//     // pdf.text(loanData?.LoanNumber || "N/A", rightX + loanNumberLabelWidth + labelSpacing, rowY);
    
//     // ROW 2: Property Address | Loan Type
//     //rowY = tableStartY + row1Height + 6.5;
    
//     pdf.setFont("helvetica", "bold");
//     pdf.text("Audit Plan Type:", rightX, rowY);
//     pdf.setFont("helvetica", "normal");
//     pdf.text(auditPlanType || "N/A", rightX + auditPlanTypeLabelWidth + labelSpacing, rowY);
    
//     // ROW 2: Property Address | Loan Type
//     rowY = tableStartY + row1Height + 6.5;
    
//     pdf.setFont("helvetica", "bold");
//     pdf.text("Property Address:", leftX, rowY);
    
//     pdf.setFont("helvetica", "normal");
//     const address = `${loanData?.CurrentAddress || ""}, ${loanData?.CurrentCity || ""}, ${loanData?.CurrentState || ""} ${loanData?.CurrentZipCode || ""}`;
//     const maxAddressWidth = colWidth - propertyAddressLabelWidth - labelSpacing - 6;
//     const addressLines = pdf.splitTextToSize(address, maxAddressWidth);
    
//     addressLines.forEach((line: string, idx: number) => {
//         pdf.text(line, leftX + propertyAddressLabelWidth + labelSpacing, rowY + (idx * 4.5));
//     });
    
//     // Right column - Loan Type (aligned to top of this row)
//     pdf.setFont("helvetica", "bold");
//     pdf.text("Loan Type:", rightX, rowY);
//     pdf.setFont("helvetica", "normal");
//     pdf.text(loanData?.LoanType || "N/A", rightX + loanTypeLabelWidth + labelSpacing, rowY);
    
//     // ROW 3: Empty | Audit Completion Date
//     rowY = tableStartY + row1Height + row2Height + 6.5;
    
//     pdf.setFont("helvetica", "bold");
//     pdf.text("Audit Completion Date:", rightX, rowY);
//     pdf.setFont("helvetica", "normal");
//     pdf.text(QcCompleteDate || "N/A", rightX + auditCompletionDateLabelWidth + labelSpacing, rowY);
    
//     cursorY = tableStartY + totalHeight + CONFIG.SPACING.sectionGap;
// };

// // const renderHeader = () => {
// //     const tableStartY = cursorY;
// //     const tableWidth = CONFIG.PAGE.contentWidth;
// //     const colWidth = tableWidth / 2;

// //     const leftX = CONFIG.PAGE.margin + 4;
// //     const rightX = CONFIG.PAGE.margin + colWidth + 4;

// //     pdf.setFontSize(CONFIG.FONTS.body);
// //     pdf.setDrawColor(180, 180, 180);
// //     pdf.setLineWidth(0.5);

// //     const labelSpacing = 2;
// //     const lineHeight = 5;
// //     const baseRowHeight = 12;

// //     // ---------------- Prepare Address ----------------
// //     pdf.setFont("helvetica", "bold");
// //     const propertyLabelWidth = pdf.getTextWidth("Property Address:");
// //     pdf.setFont("helvetica", "normal");

// //     const address = `${loanData?.CurrentAddress || ""}, ${
// //         loanData?.CurrentCity || ""
// //     }, ${loanData?.CurrentState || ""} ${
// //         loanData?.CurrentZipCode || ""
// //     }`;

// //     const maxAddressWidth =
// //         colWidth - propertyLabelWidth - labelSpacing - 8;

// //     const addressLines = pdf.splitTextToSize(
// //         address || "N/A",
// //         maxAddressWidth
// //     );

// //     const propertyRowHeight = Math.max(
// //         baseRowHeight,
// //         addressLines.length * lineHeight + 6
// //     );

// //     // Heights
// //     const row1Height = baseRowHeight;
// //     const row2Height = propertyRowHeight;
// //     const row3Height = baseRowHeight; // Loan Type
// //     const row4Height = baseRowHeight; // Completion Date

// //     const totalHeight =
// //         row1Height + row2Height + row3Height + row4Height;

// //     // ---------------- Draw Outer Border ----------------
// //     pdf.rect(
// //         CONFIG.PAGE.margin,
// //         tableStartY,
// //         tableWidth,
// //         totalHeight
// //     );

// //     // Vertical divider
// //     pdf.line(
// //         CONFIG.PAGE.margin + colWidth,
// //         tableStartY,
// //         CONFIG.PAGE.margin + colWidth,
// //         tableStartY + totalHeight
// //     );

// //     // ---------------- Horizontal Lines ----------------

// //     // After Row 1 (full width)
// //     pdf.line(
// //         CONFIG.PAGE.margin,
// //         tableStartY + row1Height,
// //         CONFIG.PAGE.margin + tableWidth,
// //         tableStartY + row1Height
// //     );

// //     // After Property row (full width)
// //     pdf.line(
// //         CONFIG.PAGE.margin,
// //         tableStartY + row1Height + row2Height,
// //         CONFIG.PAGE.margin + tableWidth,
// //         tableStartY + row1Height + row2Height
// //     );

// //     // After Loan Type (right side only)
// //     pdf.line(
// //         CONFIG.PAGE.margin + colWidth,
// //         tableStartY + row1Height + row2Height + row3Height,
// //         CONFIG.PAGE.margin + tableWidth,
// //         tableStartY + row1Height + row2Height + row3Height
// //     );

// //     // ---------------- CONTENT ----------------

// //     // Helper for vertical center
// //     const getCenteredY = (startY: number, height: number) =>
// //         startY + height / 2 + 2;

// //     // -------- Row 1 --------
// //     let rowY = getCenteredY(tableStartY, row1Height);

// //     pdf.setFont("helvetica", "bold");
// //     pdf.text("Borrower Name:", leftX, rowY);
// //     pdf.setFont("helvetica", "normal");
// //     pdf.text(
// //         loanData?.BorrowersFirstName || "N/A",
// //         leftX + pdf.getTextWidth("Borrower Name:") + labelSpacing,
// //         rowY
// //     );

// //     pdf.setFont("helvetica", "bold");
// //     pdf.text("Loan Number:", rightX, rowY);
// //     pdf.setFont("helvetica", "normal");
// //     pdf.text(
// //         loanData?.LoanNumber || "N/A",
// //         rightX + pdf.getTextWidth("Loan Number:") + labelSpacing,
// //         rowY
// //     );

// //     // -------- Row 2 (Property + Audit Plan) --------
// //     const propertyStartY = tableStartY + row1Height;
// //     rowY = propertyStartY + 8;

// //     pdf.setFont("helvetica", "bold");
// //     pdf.text("Property Address:", leftX, rowY);

// //     pdf.setFont("helvetica", "normal");
// //     addressLines.forEach((line: string, i: number) => {
// //         pdf.text(
// //             line,
// //             leftX + propertyLabelWidth + labelSpacing,
// //             rowY + i * lineHeight
// //         );
// //     });

// //     // Audit Plan Type aligned to center of property row
// //     const auditPlanY = getCenteredY(propertyStartY, row2Height);

// //     pdf.setFont("helvetica", "bold");
// //     pdf.text("Audit Plan Type:", rightX, auditPlanY);
// //     pdf.setFont("helvetica", "normal");
// //     pdf.text(
// //         auditPlanType || "N/A",
// //         rightX +
// //             pdf.getTextWidth("Audit Plan Type:") +
// //             labelSpacing,
// //         auditPlanY
// //     );

// //     // -------- Row 3 (Loan Type) --------
// //     const row3Start =
// //         tableStartY + row1Height + row2Height;

// //     rowY = getCenteredY(row3Start, row3Height);

// //     pdf.setFont("helvetica", "bold");
// //     pdf.text("Loan Type:", rightX, rowY);
// //     pdf.setFont("helvetica", "normal");
// //     pdf.text(
// //         loanData?.LoanType || "N/A",
// //         rightX + pdf.getTextWidth("Loan Type:") + labelSpacing,
// //         rowY
// //     );

// //     // -------- Row 4 (Completion Date) --------
// //     const row4Start =
// //         tableStartY +
// //         row1Height +
// //         row2Height +
// //         row3Height;

// //     rowY = getCenteredY(row4Start, row4Height);

// //     pdf.setFont("helvetica", "bold");
// //     pdf.text("Audit Completion Date:", rightX, rowY);
// //     pdf.setFont("helvetica", "normal");
// //     pdf.text(
// //         QcCompleteDate || "N/A",
// //         rightX +
// //             pdf.getTextWidth("Audit Completion Date:") +
// //             labelSpacing,
// //         rowY
// //     );

// //     cursorY =
// //         tableStartY + totalHeight + CONFIG.SPACING.sectionGap;
// // };






// // ==================== CATEGORY SECTION ====================
// const renderCategory = (categoryName: string) => {
//     checkPageBreak(15);

//     // Category Header with background
//     pdf.setFillColor(CONFIG.COLORS.primary.r, CONFIG.COLORS.primary.g, CONFIG.COLORS.primary.b);
//     pdf.rect(CONFIG.PAGE.margin, cursorY, CONFIG.PAGE.contentWidth, 10, "F");
    
//     pdf.setFontSize(CONFIG.FONTS.sectionHeader);
//     pdf.setFont("helvetica", "bold");
//     pdf.setTextColor(CONFIG.COLORS.white.r, CONFIG.COLORS.white.g, CONFIG.COLORS.white.b);
//     pdf.text(categoryName, CONFIG.PAGE.margin + 3, cursorY + 7);
    
//     pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
//     cursorY += 14;
// };

// // ==================== QUESTION SECTION (NO TABLE - FIXED SPACING) ====================
// const renderQuestion = (questionNum: number, questionText: string, response: any) => {
//     // Calculate space needed for question
//     const qLines = pdf.splitTextToSize(
//         questionText,
//         CONFIG.PAGE.contentWidth - 20
//     );
    
//     let spaceNeeded = (qLines.length) * CONFIG.SPACING.lineHeight + 15;
    
//     // Add space for defect details if present
//     if (response?.Response === "Finding") {
//         spaceNeeded += 100;
//     }

//     checkPageBreak(spaceNeeded);

//     // Question Number and Text
//     pdf.setFontSize(CONFIG.FONTS.question);
//     pdf.setFont("helvetica", "bold");
//     pdf.setTextColor(CONFIG.COLORS.primary.r, CONFIG.COLORS.primary.g, CONFIG.COLORS.primary.b);
    
//     // ✅ FIXED: Calculate dynamic width for question number
//     const questionLabel = `Q${questionNum}:`;
//     const questionLabelWidth = pdf.getTextWidth(questionLabel);
//     pdf.text(questionLabel, CONFIG.PAGE.margin + 2, cursorY);
    
//     pdf.setFont("helvetica", "normal");
//     pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
    
//     // ✅ FIXED: Start question text after the question number with proper spacing
//     const questionTextStartX = CONFIG.PAGE.margin + 2 + questionLabelWidth + 3;
//     const questionMaxWidth = CONFIG.PAGE.contentWidth - (questionTextStartX - CONFIG.PAGE.margin);
//     const questionOnlyText = pdf.splitTextToSize(questionText, questionMaxWidth);
    
//     questionOnlyText.forEach((line: string) => {
//         pdf.text(line, questionTextStartX, cursorY);
//         cursorY += CONFIG.SPACING.lineHeight;
//     });

//     cursorY += 2;

//     // Answer (No Table Format - MINIMAL SPACING)
//     pdf.setFontSize(CONFIG.FONTS.body);
//     pdf.setFont("helvetica", "bold");
//     pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
    
//     const answerLabelWidth = pdf.getTextWidth("Answer:");
//     pdf.text("Answer:", CONFIG.PAGE.margin + 5, cursorY);
    
//     pdf.setFont("helvetica", "normal");
//     const answerText = response?.Response || "No Response";
//     const answerColor = response?.Response === "Finding" ? { r: 200, g: 50, b: 50 } : { r: 0, g: 0, b: 0 };
//     pdf.setTextColor(answerColor.r, answerColor.g, answerColor.b);
//     pdf.text(answerText, CONFIG.PAGE.margin + 5 + answerLabelWidth + 2, cursorY);
//     pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
    
//     // FIXED: Only add minimal spacing after answer
//     cursorY += CONFIG.SPACING.lineHeight;

//     // Render Defect Details if Finding
//     if (response?.Response === "Finding") {
//         renderDefectDetails(response);
//     } else {
//         // For non-Finding answers, add minimal gap before separator
//         cursorY += 2;
//     }

//     // Separator and gap
//     drawSeparator(cursorY, false);
//     cursorY += CONFIG.SPACING.questionGap;
// };

// // ==================== DEFECT DETAILS SECTION (TABLE FORMAT) ====================
// // const renderDefectDetails = (response: any) => {
// //     cursorY += 2;
    
// //     // Defect Details Header
// //     pdf.setFillColor(252, 245, 245);
// //     pdf.rect(CONFIG.PAGE.margin + 5, cursorY, CONFIG.PAGE.contentWidth - 10, 8, "F");
    
// //     pdf.setFontSize(CONFIG.FONTS.question);
// //     pdf.setFont("helvetica", "bold");
// //     pdf.setTextColor(180, 50, 50);
// //     pdf.text("Defect Details", CONFIG.PAGE.margin + 8, cursorY + 5.5);
// //     pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
// //     cursorY += 10;

// //     // Defect Information Table
// //     const tableStartY = cursorY;
// //     const tableWidth = CONFIG.PAGE.contentWidth - 10;
// //     const labelColWidth = 40;
// //     const valueColWidth = tableWidth - labelColWidth;
// //     const rowHeight = 7;
    
// //     const defectFields = [
// //         { label: "Category", value: response.DefectCategory || "" },
// //         { label: "Subcategory", value: response.DefectSubCategory || "" },
// //         { label: "Defect Name", value: response.DefectName || "" },
// //         { label: "Severity", value: response.SeverityRating || "" },
// //         { label: "Area Responsible", value: response.AreaResponsible?.AreaResponsibleName || "" },
// //         { label: "Detail", value: response.DefectDetail || "" },
// //     ];

// //     pdf.setFontSize(CONFIG.FONTS.body - 1);
// //     pdf.setDrawColor(200, 200, 200);
    
// //     defectFields.forEach((field, idx) => {
// //         checkPageBreak(15);
        
// //         const rowY = cursorY;
        
// //         // Background color (alternating)
// //         if (idx % 2 === 0) {
// //             pdf.setFillColor(250, 250, 250);
// //         } else {
// //             pdf.setFillColor(255, 255, 255);
// //         }
        
// //         // Calculate required height based on text wrapping
// //         const maxValueWidth = valueColWidth - 4;
// //         const valueLines = pdf.splitTextToSize(field.value, maxValueWidth);
// //         const actualRowHeight = Math.max(rowHeight, valueLines.length * 4.5 + 2);
        
// //         // Draw background
// //         pdf.rect(CONFIG.PAGE.margin + 5, rowY, tableWidth, actualRowHeight, "F");
        
// //         // Row border
// //         pdf.rect(CONFIG.PAGE.margin + 5, rowY, tableWidth, actualRowHeight, "S");
        
// //         // Vertical line between columns
// //         pdf.line(
// //             CONFIG.PAGE.margin + 5 + labelColWidth, 
// //             rowY, 
// //             CONFIG.PAGE.margin + 5 + labelColWidth, 
// //             rowY + actualRowHeight
// //         );
        
// //         // Label (bold)
// //         pdf.setFont("helvetica", "bold");
// //         pdf.setTextColor(60, 60, 60);
// //         pdf.text(field.label, CONFIG.PAGE.margin + 7, rowY + 4.5);
        
// //         // Value (normal)
// //         pdf.setFont("helvetica", "normal");
// //         pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
        
// //         // Render multi-line values
// //         valueLines.forEach((line: string, lineIdx: number) => {
// //             pdf.text(line, CONFIG.PAGE.margin + 7 + labelColWidth, rowY + 4.5 + (lineIdx * 4.5));
// //         });
        
// //         cursorY += actualRowHeight;
// //     });

// //     // Validations Table
// //     if (response.Validations && response.Validations.length > 0) {
// //         cursorY += 6;
// //         checkPageBreak(20);
        
// //         pdf.setFont("helvetica", "bold");
// //         pdf.setFontSize(CONFIG.FONTS.body);
// //         pdf.setTextColor(180, 50, 50);
// //         pdf.text("Validations", CONFIG.PAGE.margin + 8, cursorY);
// //         cursorY += 8;

// //         response.Validations.forEach((val: any, valIdx: number) => {
// //             checkPageBreak(40);
            
// //             // Validation header
// //             pdf.setFillColor(245, 245, 250);
// //             pdf.rect(CONFIG.PAGE.margin + 8, cursorY, tableWidth - 6, 7, "FD");
// //             pdf.setFontSize(CONFIG.FONTS.body);
// //             pdf.setFont("helvetica", "bold");
// //             pdf.setTextColor(60, 60, 120);
// //             pdf.text(`Validation`, CONFIG.PAGE.margin + 10, cursorY + 4.5);
// //             cursorY += 10;

// //             const validationFields = [
// //                 { label: "Comment", value: val.Comment?.replace(/<[^>]*>/g, "") || "" },
// //                 { label: "Reason", value: val.Reason || "" },
// //                 { label: "Status", value: val.Status || "" },
// //                 { label: "Validated On", value: val.CreatedDate || "" },
// //                 { label: "Created By", value: val.CreatedBy || val.CreatedBy2 || "" },
// //             ];

// //             pdf.setFontSize(CONFIG.FONTS.body - 1);
            
// //             validationFields.forEach((vField, vIdx) => {
// //                 if (vField.value) {
// //                     checkPageBreak(12);
                    
// //                     const vRowY = cursorY;
                    
// //                     // Calculate required height
// //                     const vMaxWidth = valueColWidth - 4;
// //                     const vValueLines = pdf.splitTextToSize(vField.value, vMaxWidth);
// //                     const vActualRowHeight = Math.max(rowHeight, vValueLines.length * 4.5 + 2);
                    
// //                     // Alternating background
// //                     if (vIdx % 2 === 0) {
// //                         pdf.setFillColor(252, 252, 252);
// //                     } else {
// //                         pdf.setFillColor(255, 255, 255);
// //                     }
                    
// //                     pdf.rect(CONFIG.PAGE.margin + 8, vRowY, tableWidth - 6, vActualRowHeight, "F");
                    
// //                     // Row border
// //                     pdf.setDrawColor(200, 200, 200);
// //                     pdf.rect(CONFIG.PAGE.margin + 8, vRowY, tableWidth - 6, vActualRowHeight, "S");
                    
// //                     // Vertical line
// //                     pdf.line(
// //                         CONFIG.PAGE.margin + 8 + labelColWidth, 
// //                         vRowY, 
// //                         CONFIG.PAGE.margin + 8 + labelColWidth, 
// //                         vRowY + vActualRowHeight
// //                     );
                    
// //                     // Label
// //                     pdf.setFont("helvetica", "bold");
// //                     pdf.setTextColor(60, 60, 60);
// //                     pdf.text(vField.label, CONFIG.PAGE.margin + 10, vRowY + 4.5);
                    
// //                     // Value
// //                     pdf.setFont("helvetica", "normal");
// //                     pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
                    
// //                     vValueLines.forEach((line: string, lineIdx: number) => {
// //                         pdf.text(line, CONFIG.PAGE.margin + 10 + labelColWidth, vRowY + 4.5 + (lineIdx * 4.5));
// //                     });
                    
// //                     cursorY += vActualRowHeight;
// //                 }
// //             });

// //             // Attachments
// //             if (val.Attachments && val.Attachments.length > 0) {
// //                 cursorY += 3;
// //                 checkPageBreak(15);
                
// //                 pdf.setFont("helvetica", "bold");
// //                 pdf.setFontSize(CONFIG.FONTS.body - 1);
// //                 pdf.setTextColor(60, 60, 60);
// //                 pdf.text("Attachments:", CONFIG.PAGE.margin + 10, cursorY);
// //                 cursorY += 5;

// //                 val.Attachments.forEach((att: any) => {
// //                     checkPageBreak(10);
                    
// //                     pdf.setFont("helvetica", "normal");
// //                     pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
// //                     pdf.text(`• ${att.FileName || "Unnamed"}`, CONFIG.PAGE.margin + 12, cursorY);
// //                     cursorY += 4;
                    
// //                     if (att.Comment) {
// //                         pdf.setFont("helvetica", "italic");
// //                         pdf.setFontSize(CONFIG.FONTS.body - 2);
// //                         const commentLines = pdf.splitTextToSize(`  ${att.Comment}`, tableWidth - 20);
// //                         commentLines.forEach((line: string) => {
// //                             pdf.text(line, CONFIG.PAGE.margin + 14, cursorY);
// //                             cursorY += 4;
// //                         });
// //                         pdf.setFontSize(CONFIG.FONTS.body - 1);
// //                     }
// //                 });
// //             }

// //             cursorY += 5;
// //         });
// //     }

// //     cursorY += 4;
// // };

// const renderDefectDetails = (response: any) => {
//     cursorY += 2;
    
//     // Defect Details Header
//     pdf.setFillColor(252, 245, 245);
//     pdf.rect(CONFIG.PAGE.margin + 5, cursorY, CONFIG.PAGE.contentWidth - 10, 8, "F");
    
//     pdf.setFontSize(CONFIG.FONTS.question);
//     pdf.setFont("helvetica", "bold");
//     pdf.setTextColor(180, 50, 50);
//     pdf.text("Defect Details", CONFIG.PAGE.margin + 8, cursorY + 5.5);
//     pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
//     cursorY += 10;

//     // Defect Information Table
//     const tableStartY = cursorY;
//     const tableWidth = CONFIG.PAGE.contentWidth - 10;
//     const labelColWidth = 40;
//     const valueColWidth = tableWidth - labelColWidth;
//     const rowHeight = 7;
    
//     const defectFields = [
//         { label: "Category", value: response.DefectCategory || "" },
//         { label: "Subcategory", value: response.DefectSubCategory || "" },
//         { label: "Defect Name", value: response.DefectName || "" },
//         { label: "Severity", value: response.SeverityRating || "" },
//         { label: "Area Responsible", value: response.AreaResponsible?.AreaResponsibleName || "" },
//         { label: "Detail", value: response.DefectDetail || "" },
//     ];

//     pdf.setFontSize(CONFIG.FONTS.body - 1);
//     pdf.setDrawColor(200, 200, 200);
    
//     defectFields.forEach((field, idx) => {
//         checkPageBreak(15);
        
//         const rowY = cursorY;
        
//         // Background color (alternating)
//         if (idx % 2 === 0) {
//             pdf.setFillColor(250, 250, 250);
//         } else {
//             pdf.setFillColor(255, 255, 255);
//         }
        
//         // Calculate required height based on text wrapping
//         const maxValueWidth = valueColWidth - 4;
//         const valueLines = pdf.splitTextToSize(field.value, maxValueWidth);
//         const actualRowHeight = Math.max(rowHeight, valueLines.length * 4.5 + 2);
        
//         // Draw background
//         pdf.rect(CONFIG.PAGE.margin + 5, rowY, tableWidth, actualRowHeight, "F");
        
//         // Row border
//         pdf.rect(CONFIG.PAGE.margin + 5, rowY, tableWidth, actualRowHeight, "S");
        
//         // Vertical line between columns
//         pdf.line(
//             CONFIG.PAGE.margin + 5 + labelColWidth, 
//             rowY, 
//             CONFIG.PAGE.margin + 5 + labelColWidth, 
//             rowY + actualRowHeight
//         );
        
//         // Label (bold)
//         pdf.setFont("helvetica", "bold");
//         pdf.setTextColor(60, 60, 60);
//         pdf.text(field.label, CONFIG.PAGE.margin + 7, rowY + 4.5);
        
//         // Value (normal)
//         pdf.setFont("helvetica", "normal");
//         pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
        
//         // Render multi-line values
//         valueLines.forEach((line: string, lineIdx: number) => {
//             pdf.text(line, CONFIG.PAGE.margin + 7 + labelColWidth, rowY + 4.5 + (lineIdx * 4.5));
//         });
        
//         cursorY += actualRowHeight;
//     });

//     // Validations Table - ALIGNED WITH DEFECT DETAILS
//     if (response.Validations && response.Validations.length > 0) {
//         cursorY += 6;
//         checkPageBreak(20);
        
//         // Validation Header (same alignment as Defect Details Header)
//         pdf.setFillColor(245, 245, 250);
//         pdf.rect(CONFIG.PAGE.margin + 5, cursorY, tableWidth, 8, "F");
        
//         pdf.setFont("helvetica", "bold");
//         pdf.setFontSize(CONFIG.FONTS.body);
//         pdf.setTextColor(60, 60, 120);
//         pdf.text("Validations", CONFIG.PAGE.margin + 8, cursorY + 5.5);
//         cursorY += 10;

//         response.Validations.forEach((val: any, valIdx: number) => {
//             checkPageBreak(40);
            
//             const validationFields = [
//                 { label: "Comment", value: val.Comment?.replace(/<[^>]*>/g, "") || "" },
//                 { label: "Reason", value: val.Reason || "" },
//                 { label: "Status", value: val.Status || "" },
//                 { label: "Validated On", value: val.CreatedDate || "" },
//                 { label: "Created By", value: val.CreatedBy || val.CreatedBy2 || "" },
//             ];

//             pdf.setFontSize(CONFIG.FONTS.body - 1);
            
//             validationFields.forEach((vField, vIdx) => {
//                 if (vField.value) {
//                     checkPageBreak(12);
                    
//                     const vRowY = cursorY;
                    
//                     // Calculate required height
//                     const vMaxWidth = valueColWidth - 4;
//                     const vValueLines = pdf.splitTextToSize(vField.value, vMaxWidth);
//                     const vActualRowHeight = Math.max(rowHeight, vValueLines.length * 4.5 + 2);
                    
//                     // Alternating background
//                     if (vIdx % 2 === 0) {
//                         pdf.setFillColor(252, 252, 252);
//                     } else {
//                         pdf.setFillColor(255, 255, 255);
//                     }
                    
//                     // ✅ FIXED: Same alignment as defect table (CONFIG.PAGE.margin + 5)
//                     pdf.rect(CONFIG.PAGE.margin + 5, vRowY, tableWidth, vActualRowHeight, "F");
                    
//                     // Row border
//                     pdf.setDrawColor(200, 200, 200);
//                     pdf.rect(CONFIG.PAGE.margin + 5, vRowY, tableWidth, vActualRowHeight, "S");
                    
//                     // Vertical line
//                     pdf.line(
//                         CONFIG.PAGE.margin + 5 + labelColWidth, 
//                         vRowY, 
//                         CONFIG.PAGE.margin + 5 + labelColWidth, 
//                         vRowY + vActualRowHeight
//                     );
                    
//                     // Label - ✅ FIXED: Same alignment (CONFIG.PAGE.margin + 7)
//                     pdf.setFont("helvetica", "bold");
//                     pdf.setTextColor(60, 60, 60);
//                     pdf.text(vField.label, CONFIG.PAGE.margin + 7, vRowY + 4.5);
                    
//                     // Value - ✅ FIXED: Same alignment (CONFIG.PAGE.margin + 7 + labelColWidth)
//                     pdf.setFont("helvetica", "normal");
//                     pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
                    
//                     vValueLines.forEach((line: string, lineIdx: number) => {
//                         pdf.text(line, CONFIG.PAGE.margin + 7 + labelColWidth, vRowY + 4.5 + (lineIdx * 4.5));
//                     });
                    
//                     cursorY += vActualRowHeight;
//                 }
//             });

//             // Attachments - ✅ FIXED: Aligned with validation table
//             if (val.Attachments && val.Attachments.length > 0) {
//                 cursorY += 3;
//                 checkPageBreak(15);
                
//                 pdf.setFont("helvetica", "bold");
//                 pdf.setFontSize(CONFIG.FONTS.body - 1);
//                 pdf.setTextColor(60, 60, 60);
//                 pdf.text("Attachments:", CONFIG.PAGE.margin + 7, cursorY);
//                 cursorY += 5;

//                 val.Attachments.forEach((att: any) => {
//                     checkPageBreak(10);
                    
//                     pdf.setFont("helvetica", "normal");
//                     pdf.setTextColor(CONFIG.COLORS.text.r, CONFIG.COLORS.text.g, CONFIG.COLORS.text.b);
//                     pdf.text(`• ${att.FileName || "Unnamed"}`, CONFIG.PAGE.margin + 10, cursorY);
//                     cursorY += 4;
                    
//                     if (att.Comment) {
//                         pdf.setFont("helvetica", "italic");
//                         pdf.setFontSize(CONFIG.FONTS.body - 2);
//                         const commentLines = pdf.splitTextToSize(`  ${att.Comment}`, tableWidth - 15);
//                         commentLines.forEach((line: string) => {
//                             pdf.text(line, CONFIG.PAGE.margin + 12, cursorY);
//                             cursorY += 4;
//                         });
//                         pdf.setFontSize(CONFIG.FONTS.body - 1);
//                     }
//                 });
//             }

//             cursorY += 5;
//         });
//     }

//     cursorY += 4;
// };

// // ==================== MAIN RENDERING ====================
// addWatermark();
// renderHeader();
// addPageNumber();

// // Iterate through categories and questions
// checklistData.checklists.forEach((category: any) => {
//     const responses = allChecklistsResponsesRef.current[category.Category];
//     if (!responses) return;

//     renderCategory(category.Category);

//     category.Questions.forEach((question: any, index: number) => {
//         const response = responses[question.QcChecklistId];
//         if (!response) return;

//         renderQuestion(index + 1, question.QuestionText, response);
//     });
// });

// // ==================== SAVE PDF ====================
// const fileName = `QC_Checklist_Report_${new Date().toISOString().split('T')[0]}.pdf`;
// pdf.save(fileName);
// };



    const Page_Activities = () => {
        return (
            <Panel header="Activities" headerTemplate={(o) => editHeaderTemplate('bg-ca-extended-7', o)} style={{ height: "77.5vh" }}>
                <ScrollPanel style={{ paddingTop: "20px", width: '100%', height: '67.5vh' }}>
                    <div className="flex flex-column w-full">
                        {
                            activityData.map((data: any, i: number) => {
                                return (
                                    <div className="flex flex-row gap-1 mt-1 w-full align-items-center ">


                                        <span className="block mr-2 ">{data.CreatedDate}</span>
                                        <Tag severity="success" value={data.ActivityName}></Tag>

                                        <span className="block  ml-2">{data.ActivityDetail}</span>
                                        <span className="block  ml-2">--{data.CreatedBy}</span>

                                    </div>
                                )
                            })
                        }
                    </div>
                </ScrollPanel>
            </Panel>
        )
    }

    const ActivePage = () => {
        switch (activePage) {
            case "Start":
                return page_Start();
                break;
            case "Checklist":
                return <Page_Questions />
                //return <Page_Questions checkListedResponseRef={checkListedResponseRef} />
                break;
            case "Loan":
                return <Page_Loan LoanData={loanData} />
                break;
            case "Attachment":
                return page_Attachment();
                break;
            case "Notes":
                return <Page_Notes />
                break;
            case "Finding":
                return <Page_Finding />
                break;
            case "NewAttachment":
                return <Page_NewAttachment />
                break;
            case "Activities":
                return <Page_Activities />
                break;
            default: return page_Start();
        }

    }

    const showTabLoading = () => {
        return (<div>
            <p></p>
            <p className="loading"></p>
            <p></p>
        </div>)
    }

    const isChecklistAvailable =
  checklistData?.checklists?.length > 0 &&
  allResponses &&
  Object.keys(allResponses).length > 0;

    return (
        <div>
            <Nav />

            <Body>
                <Toast ref={toast} position="bottom-center" />
                <div>

                    <div className="flex justify-content-between">
                        {mode == "FINDING" ?
                            <h1>{auditPlanType} Audit Finding - {selectedAuditFinding.RecordName}</h1>
                            :
                            <h1>{auditPlanType} Audit View - {loanData.LoanName}</h1>
                        }

                        {/* <span className="p-buttonset">
                        <Button label="New Contact" />
                        <Button label="Edit" />
                        <Button label="New Opportunity" />
                        <Menu model={items} popup ref={menuRight} id="popup_menu_right" popupAlignment="right" />
                        <Button icon="pi pi-angle-down" className="mr-2" onClick={(event) => menuRight.current.toggle(event)} aria-controls="popup_menu_right" aria-haspopup />
                    </span> */}
                    </div>

                    <div className="mt-2 grid">
                        <div className="col-4">
                            <Accordion multiple activeIndex={mode == "QC" ? [0] : [0]} >
                                <AccordionTab
                                    header={
                                        Object.keys(loanData).length == 0 ?
                                            <div>
                                                <span>Loan Detail </span><div className="loader"></div>
                                            </div>
                                            :
                                            <span>Loan Detail</span>
                                    }
                                    pt={{ headerAction: () => ({ className: 'bg-ca-extended-1' }) }}
                                >
                                    {Object.keys(loanData).length == 0 ?
                                        showTabLoading()
                                        :
                                        <div className="grid m-0">

                                            <div className='col-12'>{loanData.LoanName}</div>
                                            <div className='col-12'>{loanData.LoanNumber}</div>
                                            <div className='col-12'>{loanData.BorrowersLastName}, {loanData.BorrowersFirstName}</div>
                                            <div className="col-12 linkButton text-base" onClick={() => getLoanDetail()}>See all details...</div>
                                        </div>
                                    }
                                </AccordionTab>

                                <AccordionTab header={
                                    auditFindingsFetched == false ?
                                        <div>
                                            <span>Findings </span><div className="loader"></div>
                                        </div>
                                        :
                                        <span>Findings ({auditFindings.length})</span>
                                }

                                    pt={{ headerAction: () => ({ className: 'bg-ca-2' }) }} >
                                    {auditFindingsFetched == false ?
                                        showTabLoading()
                                        :
                                        <p className="m-0">
                                            {mode == "QC" ?
                                                auditFindings.map((data: any) => {
                                                    return (
                                                        <div className="grid">
                                                            <div className="col linkButton text-base" onClick={() => getFindingDetail(data)}>{data.RecordName}</div>
                                                        </div>
                                                    )
                                                }
                                                )
                                                : <div className="grid">
                                                    <div className="col linkButton text-base" onClick={() => getFindingDetail(selectedAuditFinding)}>{selectedAuditFinding.RecordName}</div>
                                                </div>
                                            }
                                        </p>
                                    }
                                </AccordionTab>


                                <AccordionTab header={
                                    noteFetched == false ?
                                        <div>
                                            <span>Notes </span><div className="loader"></div>
                                        </div>
                                        :
                                        <span>Notes ({noteData.length})</span>

                                } pt={{ headerAction: () => ({ className: 'bg-ca-extended-4' }) }}>
                                    {noteFetched == false ?
                                        showTabLoading()
                                        :
                                        <span>
                                            <div className="grid m-0">
                                                {
                                                    noteData.map((data: any, i: number) => {
                                                        if (i > 2)
                                                            return (<></>)
                                                        else
                                                            return (
                                                                <div className="mb-1 w-full">
                                                                    {i > 0 ? <Divider style={{ margin: "1rem 0" }} /> : ""}
                                                                    {data.Note.length < 100 ?
                                                                        <span className="block note-display">{data.Note}</span>
                                                                        :
                                                                        <span className="block note-display">{data.Note.substr(0, 100)}...<span onClick={() => setActivePage('Notes')} className="linkButton">more</span></span>
                                                                    }
                                                                    <span className="block font-italic mt-1 text-sm text-right">--{data.CreatedBy}, {data.CreatedDate}</span>
                                                                </div>
                                                            )
                                                    })
                                                }
                                                {noteData.length > 3 ?
                                                    <div className="linkButton text-base" onClick={() => setActivePage('Notes')}>
                                                        See all notes
                                                    </div>

                                                    : ""
                                                }
                                            </div>
                                        </span>
                                    }
                                </AccordionTab>
                                <AccordionTab header={
                                    attachmentDataFetched == false ?
                                        <div>
                                            <span>Attachments </span><div className="loader"></div>
                                        </div>
                                        :
                                        <span>Attachments ({attachmentData.length})</span>
                                } pt={{ headerAction: () => ({ className: 'bg-ca-extended-5' }) }}>
                                    {attachmentDataFetched == false ?
                                        showTabLoading()
                                        :
                                        <span>
                                            <div className="grid m-0">
                                                <p className="m-0">
                                                    <ol className="checklist-set">
                                                        {
                                                            attachmentData.map((data: any) => {

                                                                return (
                                                                    <li><div className="linkButton text-base" style={{ display: 'inline' }} onClick={() => getAttachmentDetail(data)}>{data.FileName}</div></li>
                                                                )
                                                            }
                                                            )
                                                        }
                                                    </ol>
                                                </p>
                                                {/* <div className='col-12'>{attachmentData.AttachmentName}</div> */}
                                            </div>
                                        </span>
                                    }
                                </AccordionTab>
                                {/* thr belo code i want to change something here */}


                                    <AccordionTab
                                                    header={
                                                        <>
                                                        {(() => {
                                                        console.log("checklistData call", checklistData);
                                                        return null;
                                                    })()}
                                                        {
                                                            checklistData.totalItems == undefined ? (
                                                            <div>
                                                                <span>Completed QC Checklist </span>
                                                                <div className="loader"></div>
                                                            </div>
                                                            ) : (
                                                            <span>Completed QC Checklist ({checklistData.totalItems})</span>
                                                            )
                                                        }
                                                    </>
                                                    }
                                                    pt={{ headerAction: () => ({ className: "bg-ca-extended-6" }) }}
                                                    >
                                                    {checklistData.totalItems == undefined ? (
                                                        showTabLoading()
                                                    ) : (
                                                        <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            width: "100%",
                                                            alignItems: "flex-start",
                                                            //minHeight: "300px",
                                                        }}
                                                        >
                                                        {/* LEFT SIDE - CATEGORY LIST */}
                                                        <div style={{ flex: 1, paddingRight: "20px" }}>
                                                            {checklistData.checklists.map((data: any) => {
                                                            if (data.totalItems)
                                                                return (
                                                                <div key={data.Category}>
                                                                    <div
                                                                    className="linkButton text-base"
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        display: "inline-block",
                                                                        marginBottom: "6px",
                                                                    }}
                                                                    onClick={() => getCheckListDetail(data, allResponses)}
                                                                    >
                                                                    {data.Category}
                                                                    </div>
                                                                </div>
                                                                );
                                                            })}
                                                        </div>

                                                        {/* RIGHT SIDE - SAVE PDF BUTTON */}
                                                        <div style={{ marginLeft: "20px", alignSelf: "flex-end" }}>
                                                            <button
                                                            disabled={!isChecklistAvailable}
                                                            onClick={generatePDF}
                                                            style={{
                                                                padding: "6px 12px",
                                                                backgroundColor: isChecklistAvailable ? "#2f6f4e" : "#ccc",
                                                                color: "white",
                                                                border: "none",
                                                                borderRadius: "4px",
                                                                cursor: isChecklistAvailable ? "pointer" : "not-allowed",
                                                            }}
                                                            >
                                                            Save PDF
                                                            </button>
                                                        </div>
                                                        </div>
                                                    )}
                                    </AccordionTab>




                                {/* <AccordionTab header="Open Activities (0)" pt={{ headerAction: () => ({ className: 'bg-ca-6' }) }}>
                                <p className="m-0">
                                    At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti
                                    quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt
                                    mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.
                                    Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus.
                                </p>
                            </AccordionTab> */}
                                {/* <AccordionTab header="Activity History" pt={{ headerAction: () => ({ className: 'bg-ca-extended-7' }) }}>
                                <p className="m-0">
                                    At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti
                                    quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt
                                    mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.
                                    Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus.
                                </p>
                            </AccordionTab> */}
                                <AccordionTab header={
                                    // make sure to change this if activity data gets fetched!
                                    activityDataFetched == false ?
                                        <div>
                                            <span>Activity History </span><div className="loader"></div>
                                        </div>
                                        :
                                        <span>Activity History ({activityData.length})</span>
                                    // "Activity History (" + activityData.length + ")"
                                }
                                    pt={{ headerAction: () => ({ className: 'bg-ca-extended-7' }) }}>
                                    {
                                        // make sure to change this if activity data gets fetched!

                                        activityDataFetched == false ?
                                            showTabLoading()
                                            :
                                            <div className="grid m-0">
                                                {
                                                    activityData.map((data: any, i: number) => {
                                                        if (i > 2)
                                                            return (<></>)
                                                        else
                                                            return (
                                                                <div className="mb-1 w-full">
                                                                    {i > 0 ? <Divider style={{ margin: "1rem 0" }} /> : ""}
                                                                    <span className="block mb-1 text-sm ">{data.CreatedDate} -{data.CreatedBy}</span>
                                                                    {data.ActivityDetail.length < 100 ?
                                                                        <span className="block note-display ml-2">{data.ActivityDetail}</span>
                                                                        :
                                                                        <span className="block note-display ml-2">{data.ActivityDetail.substr(0, 100)}...<span onClick={() => setActivePage('Activities')} className="linkButton">more</span></span>
                                                                    }
                                                                </div>
                                                            )
                                                    })
                                                }
                                                {activityData.length > 0 ?
                                                    <div className="linkButton mt-3 text-base" onClick={() => setActivePage('Activities')}>
                                                        See all activities
                                                    </div>
                                                    : ""}
                                            </div>
                                    }
                                </AccordionTab>
                            </Accordion>
                        </div>
                        <div className="col-8">
                            <ActivePage />
                            {/* {getActivePage()} */}
                        </div>
                    </div>
                </div>
            </Body>
        </div>
    )
}
